/* eslint-disable */ import { $DomainEntityReflection, EnhancedAliasReflection } from '@salsita-ai/platform-project-sdk/domain';
import { AnchorBase, AnchorSingleFeetBase, AnchorSinglePlatformBase, AnglePictureFrameBase, AnglePictureFrameCTCBase, AnglePictureFrameSingleBase, ApronBasic, ApronNone, ArchBase, ArchSingleBase, BellhouseBase, BellhouseSingleFeetBase, BellhouseSinglePlatformBase, BellyStretchedBase, BenchBasic, BoatShapeTop, BoxFrameBase, BrewerBase, BrewerSingleBase, CaseyBase, ConnectedXBase, CraftsmanBase, CraftsmanSingleBase, CrescentBase, CrescentSingleBase, DanaBase, DanaSingleBase, DremorTurnedBase, EllipticalOvalTop, FranklinBase, FranklinSingleFeetBase, FranklinSinglePlatformBase, HerricksonTurnedBase, HershBase, IvyBase, MantisBase, MarksBase, MeredithBase, MeredithSingleFeetBase, MeredithSinglePlatformBase, MidModernTaperBase, NarrowEnglishTurnedBase, OldEnglishTurnedBase, OswaldBase, OswaldSingleBase, PeruStretchedBase, RacetrackOvalTop, RectangleTop, ReededBase, ReflectionBase, ReflectionCTCBase, RishBase, RishSingleBase, RogersBase, RogersSinglePlatformBase, RoundTop, SinglePostBase, SinglePostSingleBase, SlagleTurnedBase, SlimConnectedXBase, SlimConnectedXSingleBase, SquareTop, Table, TamaraBase, TamaraSingleBase, TraditionalBase, TraditionalFlushBase, TriflectionBase, TuscanBase, TuscanSingleFeetBase, TuscanSinglePlatformBase, WaldenBase, WaldenSingleBase, XBase, XMetalBase, XMetalSingleBase, XSingleBase } from './model/index.js';
export const constants = {
    ApronBasic: {
        $apronThickness: 1.5,
        $insetFromEdge: 2,
        $apronThicknessWithFourLegs: 3,
        $insetFromEdgeWithFourLegs: 1.5,
        $apronDataMap: {
            RectangleTop: {
                objectName: 'APRON_RECTANGLE',
                sizing: {
                    length: {
                        scaleZero: 64,
                        scaleOne: 120
                    },
                    width: {
                        scaleZero: 32,
                        scaleOne: 52
                    },
                    thickness: {
                        scaleZero: 1.5,
                        scaleOne: 2.5
                    }
                }
            },
            SquareTop: {
                objectName: 'APRON_RECTANGLE',
                sizing: {
                    length: {
                        scaleZero: 64,
                        scaleOne: 120
                    },
                    width: {
                        scaleZero: 32,
                        scaleOne: 52
                    },
                    thickness: {
                        scaleZero: 1.5,
                        scaleOne: 2.5
                    }
                }
            },
            RoundTop: {
                objectName: 'APRON_ROUND',
                sizing: {
                    width: {
                        scaleZero: 32,
                        scaleOne: 52
                    },
                    length: {
                        scaleZero: 32,
                        scaleOne: 52
                    },
                    thickness: {
                        scaleZero: 1.5,
                        scaleOne: 2.5
                    },
                    stretch: {
                        scaleZero: 32,
                        scaleOne: 42
                    }
                }
            },
            EllipticalOvalTop: {
                objectName: 'APRON_ROUND',
                sizing: {
                    width: {
                        scaleZero: 32,
                        scaleOne: 52
                    },
                    length: {
                        scaleZero: 32,
                        scaleOne: 52
                    },
                    thickness: {
                        scaleZero: 1.5,
                        scaleOne: 2.5
                    },
                    stretch: {
                        scaleZero: 32,
                        scaleOne: 42
                    }
                }
            },
            RacetrackOvalTop: {
                objectName: 'APRON_ROUND',
                sizing: {
                    width: {
                        scaleZero: 32,
                        scaleOne: 52
                    },
                    length: {
                        scaleZero: 32,
                        scaleOne: 52
                    },
                    thickness: {
                        scaleZero: 1.5,
                        scaleOne: 2.5
                    },
                    stretch: {
                        scaleZero: 32,
                        scaleOne: 42
                    }
                }
            },
            BoatShapeTop: {
                objectName: 'APRON_BOAT',
                sizing: {
                    width: {
                        scaleZero: 32,
                        scaleOne: 52
                    },
                    length: {
                        scaleZero: 64,
                        scaleOne: 120
                    },
                    thickness: {
                        scaleZero: 1.41,
                        scaleOne: 2.41
                    },
                    stretch: {
                        scaleZero: 64,
                        scaleOne: 84
                    }
                }
            }
        }
    },
    BaseDoubleLeg: {
        $scaleLowerBreakpoint: 38,
        $scaleUpperBreakpoint: 46,
        $defaultCrossbraceObjectName: 'CROSS_BRACE',
        $crossbraceDataMap: {
            StandardCrossbrace: {
                objectName: 'CROSS_BRACE',
                sizing: {
                    width: {
                        scaleZero: 4.5,
                        scaleOne: 6.5
                    },
                    length: {
                        scaleZero: 44,
                        scaleOne: 54
                    },
                    height: {
                        scaleZero: 3,
                        scaleOne: 6
                    },
                    scale: {
                        scaleZero: 4.5,
                        scaleOne: 6.75,
                        increment: 1.75
                    }
                }
            },
            NotchedCrossbrace: {
                objectName: 'CROSS_BRACE_NOTCHED',
                sizing: {
                    width: {
                        scaleZero: 4.5,
                        scaleOne: 6.5
                    },
                    length: {
                        scaleZero: 44,
                        scaleOne: 54
                    },
                    height: {
                        scaleZero: 3,
                        scaleOne: 6
                    },
                    scale: {
                        scaleZero: 4.5,
                        scaleOne: 6.75,
                        increment: 1.75
                    }
                }
            }
        }
    },
    BaseFourLeg: {
        $widthIndicatorFixedY: 0,
        $widthIndicatorFixedZ: 0,
        $widthIndicatorExtrusionZ: 0
    },
    BaseSingleLeg: {
        $platformHeight: 2.5,
        $platformToTopRatio: 0.55,
        $scaleLowerBreakpoint: 52,
        $scaleUpperBreakpoint: 76,
        $defaultTopWidthForSingleLeg: 60,
        $defaultTopLengthForSingleLeg: 60,
        $platformDataMap: {
            RectangleTop: {
                objectName: 'PLATFORM_SQUARE',
                sizing: {
                    width: {
                        scaleZero: 33,
                        scaleOne: 43
                    },
                    length: {
                        scaleZero: 33,
                        scaleOne: 43
                    }
                }
            },
            SquareTop: {
                objectName: 'PLATFORM_SQUARE',
                sizing: {
                    width: {
                        scaleZero: 33,
                        scaleOne: 43
                    },
                    length: {
                        scaleZero: 33,
                        scaleOne: 43
                    }
                }
            },
            RoundTop: {
                objectName: 'PLATFORM_ROUND',
                sizing: {
                    width: {
                        scaleZero: 31,
                        scaleOne: 41
                    },
                    length: {
                        scaleZero: 31,
                        scaleOne: 41
                    }
                }
            },
            EllipticalOvalTop: {
                objectName: 'PLATFORM_ELLIPSE',
                sizing: {
                    width: {
                        scaleZero: 25,
                        scaleOne: 35
                    },
                    length: {
                        scaleZero: 42,
                        scaleOne: 52
                    }
                }
            },
            RacetrackOvalTop: {
                objectName: 'PLATFORM_RACETRACK',
                sizing: {
                    width: {
                        scaleZero: 25,
                        scaleOne: 35
                    },
                    length: {
                        scaleZero: 42,
                        scaleOne: 52
                    }
                }
            },
            BoatShapeTop: {
                objectName: 'PLATFORM_BOAT',
                sizing: {
                    width: {
                        scaleZero: 26,
                        scaleOne: 36
                    },
                    length: {
                        scaleZero: 42,
                        scaleOne: 52
                    }
                }
            }
        }
    },
    Base: {
        $topWidthLowerLimitForBaseWidth: 28,
        $metalRepeatRatio: 6,
        $defaultHeight: 30,
        $defaultHeightWithPlatform: 27.5,
        $breakpointScaleIncrement: 1.75,
        $baseDataMap: {
            AnchorBase: {
                type: 'AnchorBase',
                label: 'Anchor',
                objectName: 'SUPPORT_ANCHOR',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/anchor.png',
                baseType: 'Pedestal',
                supportsCrossBrace: true,
                crossbraceType: 'NotchedCrossbrace',
                crossbraceData: {
                    offsetY: 0,
                    height: 3,
                    width: 4.5,
                    lengthExtension: -2.5
                },
                sizing: {
                    width: {
                        scaleZero: 25,
                        scaleOne: 35
                    },
                    scale: {
                        scaleZero: 25,
                        scaleOne: 37.5,
                        increment: 1.75
                    },
                    feetThickness: 6,
                    feetThicknessScaleOne: 9,
                    baseThickness: 8.75,
                    baseThicknessScaleOne: 13.125,
                    baseThicknessCenterY: 10.9,
                    baseThicknessCenterYScaleOne: 10.9
                },
                pricing: {
                    basePrice: 0
                }
            },
            AnchorSingleFeetBase: {
                type: 'AnchorSingleFeetBase',
                label: 'Anchor with Feet',
                objectName: 'SUPPORT_ANCHOR_SINGLE_FEET',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/anchor-feet.png',
                baseType: 'Pedestal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 36,
                        scaleOne: 46
                    },
                    length: {
                        scaleZero: 36,
                        scaleOne: 46
                    },
                    scale: {
                        scaleZero: 36,
                        scaleOne: 54,
                        increment: 1.75
                    },
                    feetThickness: 7,
                    feetThicknessScaleOne: 10.5,
                    baseThickness: 10.5,
                    baseThicknessScaleOne: 15.75,
                    baseThicknessCenterY: 11,
                    baseThicknessCenterYScaleOne: 11
                },
                pricing: {
                    basePrice: 0
                }
            },
            AnchorSinglePlatformBase: {
                type: 'AnchorSinglePlatformBase',
                label: 'Anchor with Platform',
                objectName: 'SUPPORT_ANCHOR_SINGLE_PLATFORM',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/anchor-platform.png',
                baseType: 'Pedestal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 26,
                        scaleOne: 36
                    },
                    length: {
                        scaleZero: 9.75,
                        scaleOne: 0
                    },
                    scale: {
                        scaleZero: 26,
                        scaleOne: 39,
                        increment: 1.75
                    },
                    baseThickness: 8.75,
                    baseThicknessScaleOne: 13.125,
                    baseThicknessCenterY: 9.25,
                    baseThicknessCenterYScaleOne: 9.25
                },
                pricing: {
                    basePrice: 0
                }
            },
            BellhouseBase: {
                type: 'BellhouseBase',
                label: 'Bellhouse',
                objectName: 'SUPPORT_BELLHOUSE',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/bellhouse.png',
                baseType: 'Pedestal',
                supportsCrossBrace: true,
                crossbraceType: 'StandardCrossbrace',
                crossbraceData: {
                    offsetY: 1.75,
                    height: 1.75,
                    width: 5,
                    lengthExtension: -2
                },
                sizing: {
                    width: {
                        scaleZero: 23.6,
                        scaleOne: 43.6
                    },
                    scale: {
                        scaleZero: 23.6,
                        scaleOne: 35.4,
                        increment: 1.75
                    },
                    feetThickness: 6,
                    feetThicknessScaleOne: 9,
                    baseThickness: 8.75,
                    baseThicknessScaleOne: 13.125,
                    baseThicknessCenterY: 13.5,
                    baseThicknessCenterYScaleOne: 13.5
                },
                pricing: {
                    basePrice: 0
                }
            },
            BellhouseSingleFeetBase: {
                type: 'BellhouseSingleFeetBase',
                label: 'Bellhouse with Feet',
                objectName: 'SUPPORT_BELLHOUSE_SINGLE_FEET',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/bellhouse-feet.png',
                baseType: 'Pedestal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 35.9,
                        scaleOne: 55.9
                    },
                    length: {
                        scaleZero: 35.9,
                        scaleOne: 55.9
                    },
                    scale: {
                        scaleZero: 35.9,
                        scaleOne: 53.85,
                        increment: 1.75
                    },
                    feetThickness: 6,
                    feetThicknessScaleOne: 9,
                    baseThickness: 8.75,
                    baseThicknessScaleOne: 13.125,
                    baseThicknessCenterY: 13.75,
                    baseThicknessCenterYScaleOne: 13.75
                },
                pricing: {
                    basePrice: 0
                }
            },
            BellhouseSinglePlatformBase: {
                type: 'BellhouseSinglePlatformBase',
                label: 'Bellhouse with Platform',
                objectName: 'SUPPORT_BELLHOUSE_SINGLE_PLATFORM',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/bellhouse-platform.png',
                baseType: 'Pedestal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 30,
                        scaleOne: 50
                    },
                    length: {
                        scaleZero: 9,
                        scaleOne: 0
                    },
                    scale: {
                        scaleZero: 30,
                        scaleOne: 45,
                        increment: 1.75
                    },
                    baseThickness: 8.75,
                    baseThicknessScaleOne: 13.125,
                    baseThicknessCenterY: 11.75,
                    baseThicknessCenterYScaleOne: 11.75
                },
                pricing: {
                    basePrice: 0
                }
            },
            BellyStretchedBase: {
                type: 'BellyStretchedBase',
                label: 'Belly Stretched',
                objectName: 'SUPPORT_BELLY_STRETCHED',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/belly-stretched.png',
                baseType: 'Pedestal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 9.96,
                        scaleOne: 19.96
                    },
                    length: {
                        scaleZero: 18.24,
                        scaleOne: 28.24
                    },
                    scale: {
                        scaleZero: 9.96,
                        scaleOne: 14.94,
                        increment: 1.75
                    },
                    baseThickness: 18.24,
                    baseThicknessScaleOne: 27.36,
                    baseThicknessCenterY: 9,
                    baseThicknessCenterYScaleOne: 9
                },
                pricing: {
                    basePrice: 0
                }
            },
            BrewerBase: {
                type: 'BrewerBase',
                label: 'Brewer',
                objectName: 'SUPPORT_BREWER',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/brewer.png',
                baseType: 'Pedestal',
                supportsCrossBrace: true,
                crossbraceType: 'StandardCrossbrace',
                crossbraceData: {
                    offsetY: 12,
                    height: 5,
                    width: 1,
                    lengthExtension: 0
                },
                sizing: {
                    width: {
                        scaleZero: 25.28,
                        scaleOne: 35.28
                    },
                    scale: {
                        scaleZero: 25.28,
                        scaleOne: 37.92,
                        increment: 1,
                        scaleUpOnly: true
                    },
                    feetThickness: 3.505,
                    feetThicknessScaleOne: 5.257,
                    baseThickness: 3.505,
                    baseThicknessScaleOne: 5.257,
                    baseThicknessCenterY: 15,
                    baseThicknessCenterYScaleOne: 15
                },
                pricing: {
                    basePrice: 0
                }
            },
            BrewerSingleBase: {
                type: 'BrewerSingleBase',
                label: 'Brewer',
                objectName: 'SUPPORT_BREWER_SINGLE',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/brewer-single.png',
                baseType: 'Pedestal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 39,
                        scaleOne: 59
                    },
                    length: {
                        scaleZero: 39,
                        scaleOne: 59
                    },
                    scale: {
                        scaleZero: 39,
                        scaleOne: 58.5,
                        increment: 1,
                        scaleUpOnly: true
                    },
                    feetThickness: 2.25,
                    feetThicknessScaleOne: 3.375,
                    baseThickness: 2.25,
                    baseThicknessScaleOne: 3.375,
                    baseThicknessCenterY: 11.75,
                    baseThicknessCenterYScaleOne: 11.75
                },
                pricing: {
                    basePrice: 0
                }
            },
            CaseyBase: {
                type: 'CaseyBase',
                label: 'Casey',
                objectName: 'SUPPORT_CASEY',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/casey.png',
                baseType: 'Pedestal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 21.7,
                        scaleOne: 25.7
                    },
                    scale: {
                        scaleZero: 21.7,
                        scaleOne: 32.55,
                        increment: 0
                    },
                    feetThickness: 8.059,
                    feetThicknessScaleOne: 13.712,
                    baseThickness: 8.059,
                    baseThicknessScaleOne: 12.088,
                    baseThicknessCenterY: 15,
                    baseThicknessCenterYScaleOne: 15
                },
                pricing: {
                    basePrice: 0
                }
            },
            CraftsmanBase: {
                type: 'CraftsmanBase',
                label: 'Craftsman',
                objectName: 'SUPPORT_CRAFTSMAN',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/craftsman.png',
                baseType: 'Pedestal',
                supportsCrossBrace: true,
                crossbraceType: 'StandardCrossbrace',
                crossbraceData: {
                    offsetY: 12,
                    height: 6,
                    width: 1,
                    lengthExtension: 0
                },
                sizing: {
                    width: {
                        scaleZero: 26.01,
                        scaleOne: 30.1
                    },
                    scale: {
                        scaleZero: 26.01,
                        scaleOne: 39.02,
                        increment: 1.25
                    },
                    feetThickness: 4.5,
                    feetThicknessScaleOne: 6.75,
                    baseThickness: 4.5,
                    baseThicknessScaleOne: 6.75,
                    baseThicknessCenterY: 15,
                    baseThicknessCenterYScaleOne: 15
                },
                pricing: {
                    basePrice: 0
                }
            },
            CraftsmanSingleBase: {
                type: 'CraftsmanSingleBase',
                label: 'Craftsman',
                objectName: 'SUPPORT_CRAFTSMAN_SINGLE',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/craftsman-single.png',
                baseType: 'Pedestal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 36.3,
                        scaleOne: 46.3
                    },
                    length: {
                        scaleZero: 36.3,
                        scaleOne: 46.3
                    },
                    scale: {
                        scaleZero: 36.3,
                        scaleOne: 54.45,
                        increment: 1.25
                    },
                    feetThickness: 4.5,
                    feetThicknessScaleOne: 6.75,
                    baseThickness: 3.5,
                    baseThicknessScaleOne: 5.25,
                    baseThicknessCenterY: 15,
                    baseThicknessCenterYScaleOne: 15
                },
                pricing: {
                    basePrice: 0
                }
            },
            CrescentBase: {
                type: 'CrescentBase',
                label: 'Crescent',
                objectName: 'SUPPORT_CRESCENT',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/crescent.png',
                baseType: 'Pedestal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 25,
                        scaleOne: 35
                    },
                    scale: {
                        scaleZero: 25,
                        scaleOne: 37.5,
                        increment: 1.25
                    },
                    feetThickness: 5,
                    feetThicknessScaleOne: 7.5,
                    baseThickness: 4,
                    baseThicknessScaleOne: 6,
                    baseThicknessCenterY: 15,
                    baseThicknessCenterYScaleOne: 15
                },
                pricing: {
                    basePrice: 0
                }
            },
            CrescentSingleBase: {
                type: 'CrescentSingleBase',
                label: 'Crescent',
                objectName: 'SUPPORT_CRESCENT_SINGLE',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/crescent-single.png',
                baseType: 'Pedestal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 35.8,
                        scaleOne: 45.8
                    },
                    length: {
                        scaleZero: 35.8,
                        scaleOne: 45.8
                    },
                    scale: {
                        scaleZero: 35.8,
                        scaleOne: 53.7,
                        increment: 1.25
                    },
                    feetThickness: 4.35,
                    feetThicknessScaleOne: 6.525,
                    baseThickness: 3.85,
                    baseThicknessScaleOne: 5.775,
                    baseThicknessCenterY: 15,
                    baseThicknessCenterYScaleOne: 15
                },
                pricing: {
                    basePrice: 0
                }
            },
            DanaBase: {
                type: 'DanaBase',
                label: 'Dana',
                objectName: 'SUPPORT_DANA',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/dana.png',
                baseType: 'Pedestal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 21,
                        scaleOne: 25
                    },
                    scale: {
                        scaleZero: 21,
                        scaleOne: 31.5,
                        increment: 1.25
                    },
                    feetThickness: 1.75,
                    feetThicknessScaleOne: 2.625,
                    baseThickness: 1.75,
                    baseThicknessScaleOne: 2.625,
                    baseThicknessCenterY: 15,
                    baseThicknessCenterYScaleOne: 15
                },
                pricing: {
                    basePrice: 0
                }
            },
            DanaSingleBase: {
                type: 'DanaSingleBase',
                label: 'Dana',
                objectName: 'SUPPORT_DANA_SINGLE',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/dana-single.png',
                baseType: 'Pedestal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 36.12,
                        scaleOne: 40.12
                    },
                    length: {
                        scaleZero: 36.12,
                        scaleOne: 40.12
                    },
                    scale: {
                        scaleZero: 36.12,
                        scaleOne: 54.18,
                        increment: 1.25
                    },
                    feetThickness: 1.75,
                    feetThicknessScaleOne: 2.625,
                    baseThickness: 1.75,
                    baseThicknessScaleOne: 2.625,
                    baseThicknessCenterY: 15,
                    baseThicknessCenterYScaleOne: 15
                },
                pricing: {
                    basePrice: 0
                }
            },
            FranklinBase: {
                type: 'FranklinBase',
                label: 'Franklin',
                objectName: 'SUPPORT_FRANKLIN',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/franklin.png',
                baseType: 'Pedestal',
                supportsCrossBrace: true,
                crossbraceType: 'StandardCrossbrace',
                crossbraceData: {
                    offsetY: 0.3,
                    height: 2,
                    width: 8,
                    lengthExtension: 0
                },
                sizing: {
                    width: {
                        scaleZero: 24.9,
                        scaleOne: 34.9
                    },
                    scale: {
                        scaleZero: 24.9,
                        scaleOne: 37.35,
                        increment: 1.75
                    },
                    feetThickness: 6.5,
                    feetThicknessScaleOne: 9.75,
                    baseThickness: 7,
                    baseThicknessScaleOne: 10.5,
                    baseThicknessCenterY: 13.1,
                    baseThicknessCenterYScaleOne: 13.1
                },
                pricing: {
                    basePrice: 0
                }
            },
            FranklinSingleFeetBase: {
                type: 'FranklinSingleFeetBase',
                label: 'Franklin with Feet',
                objectName: 'SUPPORT_FRANKLIN_SINGLE_FEET',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/franklin-feet.png',
                baseType: 'Pedestal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 36.2,
                        scaleOne: 46.2
                    },
                    length: {
                        scaleZero: 36.2,
                        scaleOne: 40.2
                    },
                    scale: {
                        scaleZero: 36.2,
                        scaleOne: 54.3,
                        increment: 1.75
                    },
                    feetThickness: 8.785,
                    feetThicknessScaleOne: 13.178,
                    baseThickness: 10.5,
                    baseThicknessScaleOne: 15.75,
                    baseThicknessCenterY: 13.25,
                    baseThicknessCenterYScaleOne: 13.25
                },
                pricing: {
                    basePrice: 0
                }
            },
            FranklinSinglePlatformBase: {
                type: 'FranklinSinglePlatformBase',
                label: 'Franklin with Platform',
                objectName: 'SUPPORT_FRANKLIN_SINGLE_PLATFORM',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/franklin-platform.png',
                baseType: 'Pedestal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 38.2,
                        scaleOne: 48.2
                    },
                    length: {
                        scaleZero: 12.3,
                        scaleOne: 0
                    },
                    scale: {
                        scaleZero: 38.2,
                        scaleOne: 57.3,
                        increment: 1.75
                    },
                    baseThickness: 10.5,
                    baseThicknessScaleOne: 15.75,
                    baseThicknessCenterY: 12.75,
                    baseThicknessCenterYScaleOne: 12.75
                },
                pricing: {
                    basePrice: 0
                }
            },
            HershBase: {
                type: 'HershBase',
                label: 'Hersh',
                objectName: 'SUPPORT_HERSH_HIRSH',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/hersh.png',
                baseType: 'Pedestal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 23,
                        scaleOne: 33
                    },
                    scale: {
                        scaleZero: 23,
                        scaleOne: 34.5,
                        increment: 1
                    },
                    feetThickness: 5,
                    feetThicknessScaleOne: 7.5,
                    baseThickness: 5,
                    baseThicknessScaleOne: 7.5,
                    baseThicknessCenterY: 15,
                    baseThicknessCenterYScaleOne: 15
                },
                pricing: {
                    basePrice: 0
                }
            },
            MarksBase: {
                type: 'MarksBase',
                label: 'Marks',
                objectName: 'SUPPORT_MARKS',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/marks.png',
                baseType: 'Pedestal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 26,
                        scaleOne: 36
                    },
                    length: {
                        scaleZero: 50,
                        scaleOne: 60.0463
                    },
                    scale: {
                        scaleZero: 26,
                        scaleOne: 39,
                        increment: 0
                    },
                    feetThickness: 50,
                    feetThicknessScaleOne: 75
                },
                pricing: {
                    basePrice: 0
                }
            },
            MeredithBase: {
                type: 'MeredithBase',
                label: 'Meredith',
                objectName: 'SUPPORT_MEREDITH',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/meredith.png',
                baseType: 'Pedestal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 25,
                        scaleOne: 35
                    },
                    scale: {
                        scaleZero: 25,
                        scaleOne: 37.5,
                        increment: 1.75
                    },
                    feetThickness: 5.5,
                    feetThicknessScaleOne: 8.25,
                    baseThickness: 8.75,
                    baseThicknessScaleOne: 13.125,
                    baseThicknessCenterY: 26.5,
                    baseThicknessCenterYScaleOne: 26.5
                },
                pricing: {
                    basePrice: 0
                }
            },
            MeredithSingleFeetBase: {
                type: 'MeredithSingleFeetBase',
                label: 'Meredith with Feet',
                objectName: 'SUPPORT_MEREDITH_SINGLE_FEET',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/meredith-feet.png',
                baseType: 'Pedestal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 34,
                        scaleOne: 44
                    },
                    length: {
                        scaleZero: 34,
                        scaleOne: 44
                    },
                    scale: {
                        scaleZero: 34,
                        scaleOne: 51,
                        increment: 1.75
                    },
                    feetThickness: 6,
                    feetThicknessScaleOne: 9,
                    baseThickness: 9.75,
                    baseThicknessScaleOne: 14.625,
                    baseThicknessCenterY: 26.25,
                    baseThicknessCenterYScaleOne: 26.25
                },
                pricing: {
                    basePrice: 0
                }
            },
            MeredithSinglePlatformBase: {
                type: 'MeredithSinglePlatformBase',
                label: 'Meredith with Platform',
                objectName: 'SUPPORT_MEREDITH_SINGLE_PLATFORM',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/meredith-platform.png',
                baseType: 'Pedestal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 30,
                        scaleOne: 40
                    },
                    length: {
                        scaleZero: 14.5,
                        scaleOne: 0
                    },
                    scale: {
                        scaleZero: 40,
                        scaleOne: 60,
                        increment: 1.75
                    },
                    baseThickness: 10.5,
                    baseThicknessScaleOne: 15.75,
                    baseThicknessCenterY: 27.25,
                    baseThicknessCenterYScaleOne: 27.25
                },
                pricing: {
                    basePrice: 0
                }
            },
            OswaldBase: {
                type: 'OswaldBase',
                label: 'Oswald',
                objectName: 'SUPPORT_OSWALD',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/oswald.png',
                baseType: 'Pedestal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 21,
                        scaleOne: 28
                    },
                    scale: {
                        scaleZero: 21,
                        scaleOne: 31.5,
                        increment: 1.25
                    },
                    feetThickness: 3.5,
                    feetThicknessScaleOne: 5.25,
                    baseThickness: 7.5,
                    baseThicknessScaleOne: 11.25,
                    baseThicknessCenterY: 15,
                    baseThicknessCenterYScaleOne: 15
                },
                pricing: {
                    basePrice: 0
                }
            },
            OswaldSingleBase: {
                type: 'OswaldSingleBase',
                label: 'Oswald',
                objectName: 'SUPPORT_OSWALD_SINGLE',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/oswald-single.png',
                baseType: 'Pedestal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 28.3,
                        scaleOne: 38.3
                    },
                    length: {
                        scaleZero: 32.3,
                        scaleOne: 43.7
                    },
                    scale: {
                        scaleZero: 28.3,
                        scaleOne: 42.45,
                        increment: 0
                    },
                    feetThickness: 3.5,
                    feetThicknessScaleOne: 5.25,
                    baseThickness: 3.5,
                    baseThicknessScaleOne: 5.25,
                    baseThicknessCenterY: 15,
                    baseThicknessCenterYScaleOne: 15
                },
                pricing: {
                    basePrice: 0
                }
            },
            PeruStretchedBase: {
                type: 'PeruStretchedBase',
                label: 'Peru Stretched',
                objectName: 'SUPPORT_PERU_STRETCHED',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/peru-stretched.png',
                baseType: 'Pedestal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 10.5,
                        scaleOne: 20.5
                    },
                    length: {
                        scaleZero: 17.5,
                        scaleOne: 27.5
                    },
                    scale: {
                        scaleZero: 10.5,
                        scaleOne: 15.75,
                        increment: 1.75
                    },
                    baseThickness: 17.5,
                    baseThicknessScaleOne: 26.25,
                    baseThicknessCenterY: 4.5,
                    baseThicknessCenterYScaleOne: 4.5
                },
                pricing: {
                    basePrice: 0
                }
            },
            ReededBase: {
                type: 'ReededBase',
                label: 'Reeded',
                objectName: 'SUPPORT_REEDED_SINGLE_MEDIUM',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/reeded.png',
                baseType: 'Pedestal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 22.75,
                        scaleOne: 32.77
                    },
                    length: {
                        scaleZero: 22.75,
                        scaleOne: 32.77
                    },
                    scale: {
                        scaleZero: 22.75,
                        scaleOne: 34.12,
                        increment: 1.75
                    }
                },
                pricing: {
                    basePrice: 0
                }
            },
            RishBase: {
                type: 'RishBase',
                label: 'Rish',
                objectName: 'SUPPORT_RISH',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/rish.png',
                baseType: 'Pedestal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 23,
                        scaleOne: 33
                    },
                    scale: {
                        scaleZero: 23,
                        scaleOne: 34.5,
                        increment: 1
                    },
                    feetThickness: 4.5,
                    feetThicknessScaleOne: 6.75,
                    baseThickness: 4.5,
                    baseThicknessScaleOne: 6.75,
                    baseThicknessCenterY: 15,
                    baseThicknessCenterYScaleOne: 15
                },
                pricing: {
                    basePrice: 0
                }
            },
            RishSingleBase: {
                type: 'RishSingleBase',
                label: 'Rish',
                objectName: 'SUPPORT_RISH_SINGLE',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/rish-single.png',
                baseType: 'Pedestal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 36,
                        scaleOne: 46
                    },
                    length: {
                        scaleZero: 36,
                        scaleOne: 46
                    },
                    scale: {
                        scaleZero: 36,
                        scaleOne: 54,
                        increment: 1
                    },
                    feetThickness: 3,
                    feetThicknessScaleOne: 4.5,
                    baseThickness: 3,
                    baseThicknessScaleOne: 4.5,
                    baseThicknessCenterY: 15,
                    baseThicknessCenterYScaleOne: 15
                },
                pricing: {
                    basePrice: 0
                }
            },
            RogersBase: {
                type: 'RogersBase',
                label: 'Rogers',
                objectName: 'SUPPORT_ROGERS_9_INCHES',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/rogers-single.png',
                baseType: 'Pedestal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 25.4,
                        scaleOne: 35.4
                    },
                    scale: {
                        scaleZero: 25.4,
                        scaleOne: 38.1,
                        increment: 1.75
                    },
                    feetThickness: 25.364,
                    feetThicknessScaleOne: 48.045,
                    baseThickness: 9,
                    baseThicknessScaleOne: 13.5,
                    baseThicknessCenterY: 15.5,
                    baseThicknessCenterYScaleOne: 15.5
                },
                pricing: {
                    basePrice: 0
                }
            },
            RogersSinglePlatformBase: {
                type: 'RogersSinglePlatformBase',
                label: 'Rogers',
                objectName: 'SUPPORT_ROGERS_SINGLE_MEDIUM',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/rogers-single.png',
                baseType: 'Pedestal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 25.36,
                        scaleOne: 35.51
                    },
                    length: {
                        scaleZero: 14.18,
                        scaleOne: 17.73
                    },
                    scale: {
                        scaleZero: 25.36,
                        scaleOne: 39.76,
                        increment: 1.75
                    }
                },
                pricing: {
                    basePrice: 0
                }
            },
            TamaraBase: {
                type: 'TamaraBase',
                label: 'Tamara',
                objectName: 'SUPPORT_TAMARA',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/tamara.png',
                baseType: 'Pedestal',
                supportsCrossBrace: true,
                crossbraceType: 'StandardCrossbrace',
                crossbraceData: {
                    offsetY: 12,
                    height: 6,
                    width: 1,
                    lengthExtension: 0
                },
                sizing: {
                    width: {
                        scaleZero: 25.1,
                        scaleOne: 37.59
                    },
                    scale: {
                        scaleZero: 25.1,
                        scaleOne: 37.65,
                        increment: 1.25
                    },
                    feetThickness: 5.49,
                    feetThicknessScaleOne: 8.234,
                    baseThickness: 5.49,
                    baseThicknessScaleOne: 8.234,
                    baseThicknessCenterY: 15,
                    baseThicknessCenterYScaleOne: 15
                },
                pricing: {
                    basePrice: 0
                }
            },
            TamaraSingleBase: {
                type: 'TamaraSingleBase',
                label: 'Tamara',
                objectName: 'SUPPORT_TAMARA_SINGLE',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/tamara-single.png',
                baseType: 'Pedestal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 37.12,
                        scaleOne: 49.52
                    },
                    length: {
                        scaleZero: 37.08,
                        scaleOne: 49.47
                    },
                    scale: {
                        scaleZero: 37.12,
                        scaleOne: 55.68,
                        increment: 1.25
                    },
                    feetThickness: 5.5,
                    feetThicknessScaleOne: 8.25,
                    baseThickness: 5.25,
                    baseThicknessScaleOne: 7.875,
                    baseThicknessCenterY: 10,
                    baseThicknessCenterYScaleOne: 10
                },
                pricing: {
                    basePrice: 0
                }
            },
            TuscanBase: {
                type: 'TuscanBase',
                label: 'Tuscan',
                objectName: 'SUPPORT_TUSCAN',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/tuscan.png',
                baseType: 'Pedestal',
                supportsCrossBrace: true,
                crossbraceType: 'NotchedCrossbrace',
                crossbraceData: {
                    offsetY: 1,
                    height: 3,
                    width: 4.5,
                    lengthExtension: -2.5
                },
                sizing: {
                    width: {
                        scaleZero: 26.1,
                        scaleOne: 36.1
                    },
                    scale: {
                        scaleZero: 26.1,
                        scaleOne: 39.15,
                        increment: 1.75
                    },
                    feetThickness: 6,
                    feetThicknessScaleOne: 9,
                    baseThickness: 8.5,
                    baseThicknessScaleOne: 12.75,
                    baseThicknessCenterY: 9.6,
                    baseThicknessCenterYScaleOne: 9.6
                },
                pricing: {
                    basePrice: 0
                }
            },
            TuscanSingleFeetBase: {
                type: 'TuscanSingleFeetBase',
                label: 'Tuscan with Feet',
                objectName: 'SUPPORT_TUSCAN_SINGLE_FEET',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/tuscan-feet.png',
                baseType: 'Pedestal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 36.1,
                        scaleOne: 46.1
                    },
                    length: {
                        scaleZero: 36.1,
                        scaleOne: 46.1
                    },
                    scale: {
                        scaleZero: 36.1,
                        scaleOne: 54.15,
                        increment: 1.75
                    },
                    feetThickness: 6.48,
                    feetThicknessScaleOne: 9.72,
                    baseThickness: 10.54,
                    baseThicknessScaleOne: 15.81,
                    baseThicknessCenterY: 8.5,
                    baseThicknessCenterYScaleOne: 8.5
                },
                pricing: {
                    basePrice: 0
                }
            },
            TuscanSinglePlatformBase: {
                type: 'TuscanSinglePlatformBase',
                label: 'Tuscan with Platform',
                objectName: 'SUPPORT_TUSCAN_SINGLE_PLATFORM',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/tuscan-platform.png',
                baseType: 'Pedestal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 30,
                        scaleOne: 40
                    },
                    length: {
                        scaleZero: 14.5,
                        scaleOne: 24.6
                    },
                    scale: {
                        scaleZero: 42,
                        scaleOne: 63,
                        increment: 1.75
                    },
                    baseThickness: 10.54,
                    baseThicknessScaleOne: 15.81,
                    baseThicknessCenterY: 7,
                    baseThicknessCenterYScaleOne: 7
                },
                pricing: {
                    basePrice: 0
                }
            },
            WaldenBase: {
                type: 'WaldenBase',
                label: 'Walden',
                objectName: 'SUPPORT_WALDEN',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/walden.png',
                baseType: 'Pedestal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 25,
                        scaleOne: 35
                    },
                    scale: {
                        scaleZero: 25,
                        scaleOne: 37.5,
                        increment: 0
                    },
                    feetThickness: 5.5,
                    feetThicknessScaleOne: 8.25,
                    baseThickness: 5.5,
                    baseThicknessScaleOne: 8.25,
                    baseThicknessCenterY: 2.1,
                    baseThicknessCenterYScaleOne: 2.1
                },
                pricing: {
                    basePrice: 0
                }
            },
            WaldenSingleBase: {
                type: 'WaldenSingleBase',
                label: 'Walden',
                objectName: 'SUPPORT_WALDEN_SINGLE',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/walden-single.png',
                baseType: 'Pedestal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 37,
                        scaleOne: 47
                    },
                    length: {
                        scaleZero: 37,
                        scaleOne: 47
                    },
                    scale: {
                        scaleZero: 37,
                        scaleOne: 55.5,
                        increment: 1.75
                    },
                    feetThickness: 6.5,
                    feetThicknessScaleOne: 11.375,
                    baseThickness: 5.5,
                    baseThicknessScaleOne: 8.25,
                    baseThicknessCenterY: 28.6,
                    baseThicknessCenterYScaleOne: 28.6
                },
                pricing: {
                    basePrice: 0
                }
            },
            XBase: {
                type: 'XBase',
                label: 'X',
                objectName: 'SUPPORT_X',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/x.png',
                baseType: 'Pedestal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 25,
                        scaleOne: 33.62
                    },
                    scale: {
                        scaleZero: 25,
                        scaleOne: 37.5,
                        increment: 0
                    },
                    feetThickness: 3,
                    feetThicknessScaleOne: 4.5,
                    baseThickness: 3,
                    baseThicknessScaleOne: 4.5,
                    baseThicknessCenterY: 15,
                    baseThicknessCenterYScaleOne: 15
                },
                pricing: {
                    basePrice: 0
                }
            },
            XSingleBase: {
                type: 'XSingleBase',
                label: 'X',
                objectName: 'SUPPORT_X_DOUBLE',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/x-single.png',
                baseType: 'Pedestal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 36,
                        scaleOne: 46.7249
                    },
                    length: {
                        scaleZero: 36,
                        scaleOne: 46.6761
                    },
                    scale: {
                        scaleZero: 36,
                        scaleOne: 54,
                        increment: 0
                    },
                    feetThickness: 1.75,
                    feetThicknessScaleOne: 2.625,
                    baseThickness: 1.75,
                    baseThicknessScaleOne: 2.625,
                    baseThicknessCenterY: 14.25,
                    baseThicknessCenterYScaleOne: 14.25
                },
                pricing: {
                    basePrice: 0
                }
            },
            AnglePictureFrameBase: {
                type: 'AnglePictureFrameBase',
                label: 'Angle Picture Frame',
                objectName: 'SUPPORT_METAL_ANGLE_PICTURE_FRAME',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/angle-picture-frame.png',
                baseType: 'Metal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 23,
                        scaleOne: 33
                    },
                    scale: {
                        scaleZero: 23,
                        scaleOne: 34.5,
                        increment: 1
                    },
                    feetThickness: 3.5,
                    feetThicknessScaleOne: 5.25,
                    baseThickness: 3.5,
                    baseThicknessScaleOne: 5.25,
                    baseThicknessCenterY: 15,
                    baseThicknessCenterYScaleOne: 15
                },
                pricing: {
                    basePrice: 0
                }
            },
            AnglePictureFrameSingleBase: {
                type: 'AnglePictureFrameSingleBase',
                label: 'Angle Picture Frame',
                objectName: 'SUPPORT_METAL_ANGLE_PICTURE_FRAME_SINGLE',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/angle-picture-frame-single.png',
                baseType: 'Metal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 36.3,
                        scaleOne: 46.3
                    },
                    length: {
                        scaleZero: 36.3,
                        scaleOne: 46.3
                    },
                    scale: {
                        scaleZero: 36.3,
                        scaleOne: 54.45,
                        increment: 1
                    },
                    feetThickness: 2,
                    feetThicknessScaleOne: 3,
                    baseThickness: 2,
                    baseThicknessScaleOne: 3,
                    baseThicknessCenterY: 15,
                    baseThicknessCenterYScaleOne: 15
                },
                pricing: {
                    basePrice: 0
                }
            },
            AnglePictureFrameCTCBase: {
                type: 'AnglePictureFrameCTCBase',
                label: 'Angle Picture Frame',
                objectName: 'SUPPORT_METAL_ANGLE_PICTURE_FRAME_CTC',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/angle-picture-frame-ctc.png',
                baseType: 'Metal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 31.3,
                        scaleOne: 41.3
                    },
                    length: {
                        scaleZero: 31.3,
                        scaleOne: 41.3
                    },
                    scale: {
                        scaleZero: 31.3,
                        scaleOne: 46.95,
                        increment: 1
                    },
                    feetThickness: 2.868,
                    feetThicknessScaleOne: 4.302,
                    baseThickness: 2.868,
                    baseThicknessScaleOne: 4.302,
                    baseThicknessCenterY: 15,
                    baseThicknessCenterYScaleOne: 15
                },
                pricing: {
                    basePrice: 0
                }
            },
            ArchBase: {
                type: 'ArchBase',
                label: 'Arch',
                objectName: 'SUPPORT_METAL_ARCH',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/arch.png',
                baseType: 'Metal',
                supportsCrossBrace: true,
                crossbraceType: 'StandardCrossbrace',
                crossbraceData: {
                    offsetY: 12,
                    height: 6,
                    width: 1,
                    lengthExtension: 0
                },
                sizing: {
                    width: {
                        scaleZero: 23,
                        scaleOne: 33
                    },
                    scale: {
                        scaleZero: 23,
                        scaleOne: 34.5,
                        increment: 1
                    },
                    feetThickness: 3,
                    feetThicknessScaleOne: 4.5,
                    baseThickness: 3,
                    baseThicknessScaleOne: 4.5,
                    baseThicknessCenterY: 15,
                    baseThicknessCenterYScaleOne: 15
                },
                pricing: {
                    basePrice: 0
                }
            },
            ArchSingleBase: {
                type: 'ArchSingleBase',
                label: 'Arch',
                objectName: 'SUPPORT_METAL_ARCH_SINGLE',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/arch-single.png',
                baseType: 'Metal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 36,
                        scaleOne: 46
                    },
                    length: {
                        scaleZero: 36,
                        scaleOne: 46
                    },
                    scale: {
                        scaleZero: 36,
                        scaleOne: 54,
                        increment: 1
                    },
                    feetThickness: 4,
                    feetThicknessScaleOne: 6,
                    baseThickness: 4,
                    baseThicknessScaleOne: 6,
                    baseThicknessCenterY: 15,
                    baseThicknessCenterYScaleOne: 15
                },
                pricing: {
                    basePrice: 0
                }
            },
            BoxFrameBase: {
                type: 'BoxFrameBase',
                label: 'Box Frame',
                objectName: 'SUPPORT_METAL_BOX_FRAME',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/box-frame.png',
                baseType: 'Metal',
                supportsCrossBrace: true,
                crossbraceType: 'StandardCrossbrace',
                crossbraceData: {
                    offsetY: 13.25,
                    height: 3.5,
                    width: 3.5,
                    lengthExtension: 0
                },
                sizing: {
                    width: {
                        scaleZero: 23,
                        scaleOne: 33
                    },
                    scale: {
                        scaleZero: 23,
                        scaleOne: 34.5,
                        increment: 1
                    },
                    feetThickness: 3,
                    feetThicknessScaleOne: 4.5,
                    baseThickness: 3.5,
                    baseThicknessScaleOne: 5.25,
                    baseThicknessCenterY: 15,
                    baseThicknessCenterYScaleOne: 15
                },
                pricing: {
                    basePrice: 0
                }
            },
            MantisBase: {
                type: 'MantisBase',
                label: 'Mantis',
                objectName: 'SUPPORT_METAL_MANTIS',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/mantis-single.png',
                baseType: 'Metal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 27.3,
                        scaleOne: 37.3
                    },
                    length: {
                        scaleZero: 48.7,
                        scaleOne: 58.7
                    },
                    scale: {
                        scaleZero: 27.3,
                        scaleOne: 40.95,
                        increment: 0
                    },
                    feetThickness: 1.5,
                    feetThicknessScaleOne: 2.25,
                    baseThickness: 3.064,
                    baseThicknessScaleOne: 4.596,
                    baseThicknessCenterY: 15,
                    baseThicknessCenterYScaleOne: 15
                },
                pricing: {
                    basePrice: 0
                }
            },
            ConnectedXBase: {
                type: 'ConnectedXBase',
                label: 'Connected X',
                objectName: 'SUPPORT_METAL_CONNECTED_X',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/connected-x.png',
                baseType: 'Metal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 25,
                        scaleOne: 35
                    },
                    scale: {
                        scaleZero: 25,
                        scaleOne: 37.5,
                        increment: 1
                    },
                    feetThickness: 4,
                    feetThicknessScaleOne: 6,
                    baseThickness: 4,
                    baseThicknessScaleOne: 6,
                    baseThicknessCenterY: 15,
                    baseThicknessCenterYScaleOne: 15
                },
                pricing: {
                    basePrice: 0
                }
            },
            SlimConnectedXBase: {
                type: 'SlimConnectedXBase',
                label: 'Slim Connected X',
                objectName: 'SUPPORT_METAL_CONNECTED_SLIM_X',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/slim-connected-x.png',
                baseType: 'Metal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 23,
                        scaleOne: 33
                    },
                    scale: {
                        scaleZero: 23,
                        scaleOne: 34.5,
                        increment: 1
                    },
                    feetThickness: 1,
                    feetThicknessScaleOne: 1.5,
                    baseThickness: 1,
                    baseThicknessScaleOne: 1.5,
                    baseThicknessCenterY: 15,
                    baseThicknessCenterYScaleOne: 15
                },
                pricing: {
                    basePrice: 0
                }
            },
            SlimConnectedXSingleBase: {
                type: 'SlimConnectedXSingleBase',
                label: 'Slim Connected X',
                objectName: 'SUPPORT_METAL_CONNECTED_SLIM_X_SINGLE',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/slim-connected-x-single.png',
                baseType: 'Metal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 36,
                        scaleOne: 51.7
                    },
                    length: {
                        scaleZero: 36,
                        scaleOne: 51.7
                    },
                    scale: {
                        scaleZero: 36,
                        scaleOne: 54,
                        increment: 1
                    },
                    feetThickness: 1,
                    feetThicknessScaleOne: 1.935,
                    baseThickness: 1,
                    baseThicknessScaleOne: 1.935,
                    baseThicknessCenterY: 14.75,
                    baseThicknessCenterYScaleOne: 14.75
                },
                pricing: {
                    basePrice: 0
                }
            },
            ReflectionBase: {
                type: 'ReflectionBase',
                label: 'Reflection',
                objectName: 'SUPPORT_METAL_REFLECTION',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/reflection.png',
                baseType: 'Metal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 23.2,
                        scaleOne: 33.2
                    },
                    length: {
                        scaleZero: 56,
                        scaleOne: 66
                    },
                    scale: {
                        scaleZero: 23.2,
                        scaleOne: 34.8,
                        increment: 1
                    },
                    feetThickness: 3.535,
                    feetThicknessScaleOne: 5.303,
                    baseThickness: 3.535,
                    baseThicknessScaleOne: 5.303,
                    baseThicknessCenterY: 15,
                    baseThicknessCenterYScaleOne: 15
                },
                pricing: {
                    basePrice: 0
                }
            },
            ReflectionCTCBase: {
                type: 'ReflectionCTCBase',
                label: 'Reflection',
                objectName: 'SUPPORT_METAL_REFLECTION_CTC',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/reflection-ctc.png',
                baseType: 'Metal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 26.2,
                        scaleOne: 36.2
                    },
                    length: {
                        scaleZero: 26.2,
                        scaleOne: 36.2
                    },
                    scale: {
                        scaleZero: 26.2,
                        scaleOne: 39.3,
                        increment: 1
                    },
                    feetThickness: 1.414,
                    feetThicknessScaleOne: 2.121,
                    baseThickness: 1.414,
                    baseThicknessScaleOne: 2.121,
                    baseThicknessCenterY: 15,
                    baseThicknessCenterYScaleOne: 15
                },
                pricing: {
                    basePrice: 0
                }
            },
            SinglePostBase: {
                type: 'SinglePostBase',
                label: 'Single Post',
                objectName: 'SUPPORT_METAL_SINGLE_POST',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/single-post.png',
                baseType: 'Metal',
                supportsCrossBrace: true,
                crossbraceType: 'StandardCrossbrace',
                crossbraceData: {
                    offsetY: 12,
                    height: 6,
                    width: 1,
                    lengthExtension: 0
                },
                sizing: {
                    width: {
                        scaleZero: 23.5,
                        scaleOne: 33.5
                    },
                    scale: {
                        scaleZero: 23.5,
                        scaleOne: 35.25,
                        increment: 1
                    },
                    feetThickness: 3,
                    feetThicknessScaleOne: 4.5,
                    baseThickness: 3,
                    baseThicknessScaleOne: 4.5,
                    baseThicknessCenterY: 13.7,
                    baseThicknessCenterYScaleOne: 13.7
                },
                pricing: {
                    basePrice: 0
                }
            },
            SinglePostSingleBase: {
                type: 'SinglePostSingleBase',
                label: 'Single Post',
                objectName: 'SUPPORT_METAL_SINGLE_POST_SINGLE',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/single-post-single.png',
                baseType: 'Metal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 33,
                        scaleOne: 43
                    },
                    length: {
                        scaleZero: 33,
                        scaleOne: 43
                    },
                    scale: {
                        scaleZero: 33,
                        scaleOne: 49.5,
                        increment: 1
                    },
                    feetThickness: 3,
                    feetThicknessScaleOne: 4.5,
                    baseThickness: 3,
                    baseThicknessScaleOne: 4.5,
                    baseThicknessCenterY: 15,
                    baseThicknessCenterYScaleOne: 15
                },
                pricing: {
                    basePrice: 0
                }
            },
            XMetalBase: {
                type: 'XMetalBase',
                label: 'X',
                objectName: 'SUPPORT_METAL_X',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/x-metal.png',
                baseType: 'Metal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 26,
                        scaleOne: 36
                    },
                    length: {
                        scaleZero: 0,
                        scaleOne: 0
                    },
                    scale: {
                        scaleZero: 26,
                        scaleOne: 39,
                        increment: 1
                    },
                    feetThickness: 4,
                    feetThicknessScaleOne: 6,
                    baseThickness: 4,
                    baseThicknessScaleOne: 6,
                    baseThicknessCenterY: 15,
                    baseThicknessCenterYScaleOne: 15
                },
                pricing: {
                    basePrice: 0
                }
            },
            XMetalSingleBase: {
                type: 'XMetalSingleBase',
                label: 'X',
                objectName: 'SUPPORT_METAL_X_DOUBLE',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/x-metal-single.png',
                baseType: 'Metal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 36,
                        scaleOne: 46
                    },
                    length: {
                        scaleZero: 36,
                        scaleOne: 46
                    },
                    scale: {
                        scaleZero: 36,
                        scaleOne: 54,
                        increment: 1
                    },
                    feetThickness: 3,
                    feetThicknessScaleOne: 4.5,
                    baseThickness: 4.624,
                    baseThicknessScaleOne: 6.936,
                    baseThicknessCenterY: 14.75,
                    baseThicknessCenterYScaleOne: 14.75
                },
                pricing: {
                    basePrice: 0
                }
            },
            TriflectionBase: {
                type: 'TriflectionBase',
                label: 'Triflection',
                objectName: 'SUPPORT_METAL_TRIFLECTION',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/triflection.png',
                baseType: 'Metal',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 22.9,
                        scaleOne: 34.5
                    },
                    scale: {
                        scaleZero: 22.9,
                        scaleOne: 34.35,
                        increment: 1
                    },
                    feetThickness: 19.855,
                    feetThicknessScaleOne: 39.783
                },
                pricing: {
                    basePrice: 0
                }
            },
            IvyBase: {
                type: 'IvyBase',
                label: 'Ivy',
                objectName: 'SUPPORT_IVY',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/ivy.png',
                baseType: 'FourLeg',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: {
                        scaleZero: 41,
                        scaleOne: 51
                    },
                    length: {
                        scaleZero: 83,
                        scaleOne: 93
                    }
                },
                pricing: {
                    basePrice: 0
                }
            },
            DremorTurnedBase: {
                type: 'DremorTurnedBase',
                label: 'Dremor Turned',
                objectName: 'SUPPORT_TURNED_DREMOR',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/dremor-turned.png',
                baseType: 'FourLeg',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: 3
                },
                positioning: {
                    legInset: 1
                },
                pricing: {
                    basePrice: 0
                }
            },
            HerricksonTurnedBase: {
                type: 'HerricksonTurnedBase',
                label: 'Herrickson Turned',
                objectName: 'SUPPORT_TURNED_HERRICKSON',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/herrickson-turned.png',
                baseType: 'FourLeg',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: 3.5
                },
                positioning: {
                    legInset: 1
                },
                pricing: {
                    basePrice: 0
                }
            },
            MidModernTaperBase: {
                type: 'MidModernTaperBase',
                label: 'Mid-Modern',
                objectName: 'SUPPORT_MID_MODERN_TAPER_ROUNDED',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/mid-modern.png',
                baseType: 'FourLeg',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: 3.5
                },
                positioning: {
                    legInset: 1
                },
                pricing: {
                    basePrice: 0
                }
            },
            NarrowEnglishTurnedBase: {
                type: 'NarrowEnglishTurnedBase',
                label: 'Narrow English Turned',
                objectName: 'SUPPORT_TURNED_ENGLISH_NARROW',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/narrow-english-turned.png',
                baseType: 'FourLeg',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: 3
                },
                positioning: {
                    legInset: 1
                },
                pricing: {
                    basePrice: 0
                }
            },
            OldEnglishTurnedBase: {
                type: 'OldEnglishTurnedBase',
                label: 'Old English Turned',
                objectName: 'SUPPORT_TURNED_OLD_ENGLISH',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/old-english-turned.png',
                baseType: 'FourLeg',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: 3.5
                },
                positioning: {
                    legInset: 1
                },
                pricing: {
                    basePrice: 0
                }
            },
            SlagleTurnedBase: {
                type: 'SlagleTurnedBase',
                label: 'Slagle Turned',
                objectName: 'SUPPORT_TURNED_SLAGLE',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/slagle-turned.png',
                baseType: 'FourLeg',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    width: 5
                },
                positioning: {
                    legInset: 1
                },
                pricing: {
                    basePrice: 0
                }
            },
            TraditionalBase: {
                type: 'TraditionalBase',
                label: 'Traditional',
                objectName: 'SUPPORT_FLUSH_LEG',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/traditional.png',
                baseType: 'FourLeg',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    height: {
                        scaleZero: 30,
                        scaleOne: 32
                    },
                    width: 3.5
                },
                positioning: {
                    legInset: 0
                },
                pricing: {
                    basePrice: 0
                }
            },
            TraditionalFlushBase: {
                type: 'TraditionalFlushBase',
                label: 'Traditional Flush',
                objectName: 'SUPPORT_FLUSH_LEG',
                importDimensionUnit: 'inch',
                thumbnailUrl: '/images/legs/traditional-flush.png',
                baseType: 'FourLeg',
                supportsCrossBrace: false,
                crossbraceType: null,
                crossbraceData: null,
                sizing: {
                    height: {
                        scaleZero: 30,
                        scaleOne: 32
                    },
                    width: 3.5
                },
                positioning: {
                    legInset: -0.04
                },
                pricing: {
                    basePrice: 0
                }
            }
        }
    },
    BenchBasic: {
        $benchHeight: 18,
        $benchTopThickness: 1.25,
        $benchTopWidth: 16,
        $benchBaseFootprint: 14,
        $benchInsetFromTable: 6,
        $benchApronThickness: 2,
        $benchApronInset: 1,
        $benchGap: 4,
        $benchLegInsetDefault: 6,
        $bevelScaleZero: 0,
        $bevelScaleOne: 1,
        $crossbraceDataMap: {
            StandardCrossbrace: {
                objectName: 'CROSS_BRACE',
                sizing: {
                    width: {
                        scaleZero: 4.5,
                        scaleOne: 6.5
                    },
                    length: {
                        scaleZero: 44,
                        scaleOne: 54
                    },
                    height: {
                        scaleZero: 3,
                        scaleOne: 6
                    },
                    scale: {
                        scaleZero: 4.5,
                        scaleOne: 6.75,
                        increment: 1.75
                    }
                }
            },
            NotchedCrossbrace: {
                objectName: 'CROSS_BRACE_NOTCHED',
                sizing: {
                    width: {
                        scaleZero: 4.5,
                        scaleOne: 6.5
                    },
                    length: {
                        scaleZero: 44,
                        scaleOne: 54
                    },
                    height: {
                        scaleZero: 3,
                        scaleOne: 6
                    },
                    scale: {
                        scaleZero: 4.5,
                        scaleOne: 6.75,
                        increment: 1.75
                    }
                }
            }
        }
    },
    RootEntity: {
        $glbFileUrl: '/models/element-furniture.glb',
        $emailSubject: 'Element Furniture - Custom Table Estimate',
        $emailBodyText: 'Thank you for submitting a design request for your custom table. Your estimate details are included below.\n\nPlease note that prices shown in our "Design Your Table" tool are estimates and may change after our team reviews your request.\n\nWe will get back to you as soon as possible. We look forward to connecting with you!',
        $emailFooterNote: 'Estimate price is approximate and may change at any time.',
        $emailFooterAddress: '18558 NW Frontage Road, Joliet, IL 60404',
        $emailFooterPhone: '847-401-7753',
        $emailFooterEmail: 'info@elementfurniture.com',
        $tableColumns: [
            'Item',
            'Description',
            'Price'
        ]
    },
    Table: {},
    TopWithWidthAndLength: {
        $leafBevelScaleZero: 0,
        $leafBevelScaleOne: 0.05
    },
    Top: {
        $minLeafAmount: 1,
        $minTopLengthForExtraBase: 144,
        $minTopLengthForDoubleBase: 55,
        $straightPartOfBevelTopThickness: 0.25,
        $minBeveledTopThickness: 1,
        $bevelScaleZero: 0,
        $bevelScaleOne: 1,
        $topDataMap: {
            RectangleTop: {
                type: 'RectangleTop',
                label: 'Rectangle',
                description: 'Rectangular tabletop',
                fileUrl: '/models/element-furniture.glb',
                objectName: 'TOP_RECTANGLE',
                objectNameCornerRadius: 'TOP_RECTANGLE_ROUND_CORNERS',
                objectNameWavy: 'TOP_RECTANGLE_WAVY_EDGE',
                objectNameDupont: 'TOP_RECTANGLE_OGEE',
                thumbnailUrl: '/images/shapes/rectangle.png',
                sizing: {
                    width: {
                        min: 30,
                        max: 60,
                        default: 42,
                        scaleZero: 32,
                        scaleOne: 52
                    },
                    length: {
                        min: 40,
                        max: 180,
                        default: 84,
                        scaleZero: 64,
                        scaleOne: 120
                    },
                    thickness: {
                        thicknessTypes: [
                            'Standard',
                            'Rolled'
                        ],
                        scaleZero: 0.5,
                        scaleOne: 2.5
                    },
                    distance: {
                        scaleDelta: 20
                    }
                },
                pricing: {
                    basePrice: 5909,
                    compoundingRate: 0.05,
                    pricingStep: 6
                },
                fatals: {
                    edgeStyleAvailableForThisTop: {
                        allowedValues: [
                            'Clean',
                            'NaturalWavy',
                            'Tumbled',
                            'Dupont',
                            'Beveled'
                        ]
                    }
                },
                warnings: {
                    lengthMightNotBeAvailableForThisTop: {
                        minValue: 144
                    },
                    thicknessTypeMightNotBeAvailableForThisTop: {
                        value: 'Thick'
                    }
                },
                notices: {
                    widthMaybeTooBigForDoor: {
                        minValue: 78
                    }
                }
            },
            SquareTop: {
                type: 'SquareTop',
                label: 'Square',
                description: 'Square tabletop',
                fileUrl: '/models/element-furniture.glb',
                objectName: 'TOP_RECTANGLE',
                objectNameCornerRadius: 'TOP_RECTANGLE_ROUND_CORNERS',
                objectNameWavy: 'TOP_RECTANGLE_WAVY_EDGE',
                objectNameDupont: 'TOP_RECTANGLE_OGEE',
                thumbnailUrl: '/images/shapes/square.png',
                sizing: {
                    width: {
                        scaleZero: 32,
                        scaleOne: 52
                    },
                    length: {
                        scaleZero: 64,
                        scaleOne: 120
                    },
                    side: {
                        min: 36,
                        max: 96,
                        default: 60
                    },
                    thickness: {
                        thicknessTypes: [
                            'Standard',
                            'Rolled'
                        ],
                        scaleZero: 0.5,
                        scaleOne: 2.5
                    },
                    distance: {
                        scaleDelta: 20
                    }
                },
                pricing: {
                    basePrice: 5241,
                    compoundingRate: 0.05,
                    pricingStep: 6
                },
                fatals: {
                    edgeStyleAvailableForThisTop: {
                        allowedValues: [
                            'Clean',
                            'NaturalWavy',
                            'Tumbled',
                            'Dupont',
                            'Beveled'
                        ]
                    }
                },
                warnings: {
                    lengthMightNotBeAvailableForThisTop: {
                        minValue: null
                    },
                    thicknessTypeMightNotBeAvailableForThisTop: {
                        value: 'Thick'
                    }
                },
                notices: {
                    widthMaybeTooBigForDoor: {
                        minValue: 78
                    }
                }
            },
            RoundTop: {
                type: 'RoundTop',
                label: 'Round',
                description: 'Round tabletop',
                fileUrl: '/models/element-furniture.glb',
                objectName: 'TOP_ROUND',
                objectNameCornerRadius: 'TOP_ROUND',
                objectNameWavy: 'TOP_ROUND',
                objectNameDupont: 'TOP_ROUND_OGEE',
                thumbnailUrl: '/images/shapes/round.png',
                sizing: {
                    width: {
                        scaleZero: 32,
                        scaleOne: 52
                    },
                    length: {
                        scaleZero: 32,
                        scaleOne: 120
                    },
                    diameter: {
                        min: 36,
                        max: 96,
                        default: 60
                    },
                    thickness: {
                        thicknessTypes: [
                            'Standard',
                            'Thick'
                        ],
                        scaleZero: 0.5,
                        scaleOne: 2.5
                    },
                    distance: {
                        scaleDelta: 20
                    }
                },
                pricing: {
                    basePrice: 3801,
                    compoundingRate: 0.05,
                    pricingStep: 6
                },
                fatals: {
                    edgeStyleAvailableForThisTop: {
                        allowedValues: [
                            'Clean',
                            'Tumbled',
                            'Dupont',
                            'Beveled'
                        ]
                    }
                },
                warnings: {
                    lengthMightNotBeAvailableForThisTop: {
                        minValue: null
                    },
                    thicknessTypeMightNotBeAvailableForThisTop: {
                        value: 'Thick'
                    }
                },
                notices: {
                    widthMaybeTooBigForDoor: {
                        minValue: 78
                    }
                }
            },
            EllipticalOvalTop: {
                type: 'EllipticalOvalTop',
                label: 'Elliptical Oval',
                description: 'Elliptical Oval tabletop',
                fileUrl: '/models/element-furniture.glb',
                objectName: 'TOP_ROUND',
                objectNameCornerRadius: 'TOP_ROUND',
                objectNameWavy: 'TOP_ROUND',
                objectNameDupont: 'TOP_ROUND_OGEE',
                thumbnailUrl: '/images/shapes/elliptical-oval.png',
                sizing: {
                    width: {
                        min: 30,
                        max: 60,
                        default: 42,
                        scaleZero: 32,
                        scaleOne: 52
                    },
                    length: {
                        min: 40,
                        max: 180,
                        default: 84,
                        scaleZero: 32,
                        scaleOne: 120
                    },
                    thickness: {
                        thicknessTypes: [
                            'Standard',
                            'Thick'
                        ],
                        scaleZero: 0.5,
                        scaleOne: 2.5
                    },
                    distance: {
                        scaleDelta: 20
                    }
                },
                pricing: {
                    basePrice: 6195,
                    compoundingRate: 0.05,
                    pricingStep: 6
                },
                fatals: {
                    edgeStyleAvailableForThisTop: {
                        allowedValues: [
                            'Clean',
                            'Tumbled',
                            'Dupont'
                        ]
                    }
                },
                warnings: {
                    lengthMightNotBeAvailableForThisTop: {
                        minValue: 144
                    },
                    thicknessTypeMightNotBeAvailableForThisTop: {
                        value: 'Thick'
                    }
                },
                notices: {
                    widthMaybeTooBigForDoor: {
                        minValue: 78
                    }
                }
            },
            RacetrackOvalTop: {
                type: 'RacetrackOvalTop',
                label: 'Racetrack Oval',
                description: 'Racetrack Oval tabletop',
                fileUrl: '/models/element-furniture.glb',
                objectName: 'TOP_HALF_CIRCLE',
                objectNameCornerRadius: 'TOP_HALF_CIRCLE',
                objectNameWavy: 'TOP_HALF_CIRCLE',
                objectNameDupont: 'TOP_HALF_CIRCLE_OGEE',
                thumbnailUrl: '/images/shapes/racetrack-oval.png',
                sizing: {
                    width: {
                        min: 30,
                        max: 60,
                        default: 42,
                        scaleZero: 32,
                        scaleOne: 52
                    },
                    length: {
                        min: 40,
                        max: 180,
                        default: 84,
                        scaleZero: 64,
                        scaleOne: 120
                    },
                    thickness: {
                        thicknessTypes: [
                            'Standard',
                            'Thick'
                        ],
                        scaleZero: 0.5,
                        scaleOne: 2.5
                    },
                    endRadius: 16,
                    distance: {
                        scaleDelta: 20
                    }
                },
                pricing: {
                    basePrice: 6195,
                    compoundingRate: 0.05,
                    pricingStep: 6
                },
                fatals: {
                    edgeStyleAvailableForThisTop: {
                        allowedValues: [
                            'Clean',
                            'Tumbled',
                            'Dupont'
                        ]
                    }
                },
                warnings: {
                    lengthMightNotBeAvailableForThisTop: {
                        minValue: 144
                    },
                    thicknessTypeMightNotBeAvailableForThisTop: {
                        value: 'Thick'
                    }
                },
                notices: {
                    widthMaybeTooBigForDoor: {
                        minValue: 78
                    }
                }
            },
            BoatShapeTop: {
                type: 'BoatShapeTop',
                label: 'Boat Shape',
                description: 'Boat Shape tabletop',
                fileUrl: '/models/element-furniture.glb',
                objectName: 'TOP_BOAT',
                objectNameCornerRadius: 'TOP_BOAT',
                objectNameWavy: 'TOP_BOAT',
                objectNameDupont: 'TOP_BOAT_OGEE',
                thumbnailUrl: '/images/shapes/boat-shape.png',
                sizing: {
                    width: {
                        min: 30,
                        max: 60,
                        default: 42,
                        scaleZero: 32,
                        scaleOne: 52
                    },
                    length: {
                        min: 40,
                        max: 180,
                        default: 84,
                        scaleZero: 64,
                        scaleOne: 120
                    },
                    thickness: {
                        thicknessTypes: [
                            'Standard',
                            'Thick'
                        ],
                        scaleZero: 0.5,
                        scaleOne: 2.5
                    },
                    distance: {
                        scaleDelta: 20
                    }
                },
                pricing: {
                    basePrice: 6195,
                    compoundingRate: 0.05,
                    pricingStep: 6
                },
                fatals: {
                    edgeStyleAvailableForThisTop: {
                        allowedValues: [
                            'Clean',
                            'Tumbled',
                            'Dupont'
                        ]
                    }
                },
                warnings: {
                    lengthMightNotBeAvailableForThisTop: {
                        minValue: 144
                    },
                    thicknessTypeMightNotBeAvailableForThisTop: {
                        value: 'Thick'
                    }
                },
                notices: {
                    widthMaybeTooBigForDoor: {
                        minValue: 78
                    }
                }
            }
        },
        $leafDataMap: {
            NoLeaf: {
                type: 'NoLeaf',
                fileUrl: '/models/element-furniture.glb',
                objectName: 'TOP_RECTANGLE',
                objectNameDupont: 'LEAVE_OGEE',
                objectNameWavy: 'LEAVE_WAVY_EDGE',
                importDimensionUnit: 'inch',
                label: 'No Leaf',
                length: 0,
                minTopLength: null,
                pricing: {
                    price: 0
                },
                purchasableAmounts: [
                    0
                ]
            },
            Standard: {
                type: 'Standard',
                fileUrl: '/models/element-furniture.glb',
                objectName: 'TOP_RECTANGLE',
                objectNameDupont: 'LEAVE_OGEE',
                objectNameWavy: 'LEAVE_WAVY_EDGE',
                importDimensionUnit: 'inch',
                label: 'Standard Leaf',
                length: 12,
                minTopLength: null,
                pricing: {
                    price: 753
                },
                purchasableAmounts: [
                    1,
                    2
                ]
            },
            Medium: {
                type: 'Medium',
                fileUrl: '/models/element-furniture.glb',
                objectName: 'TOP_RECTANGLE',
                objectNameDupont: 'LEAVE_OGEE',
                objectNameWavy: 'LEAVE_WAVY_EDGE',
                importDimensionUnit: 'inch',
                label: 'Medium Leaf',
                length: 18,
                minTopLength: null,
                pricing: {
                    price: 823
                },
                purchasableAmounts: [
                    1,
                    2
                ]
            },
            Large: {
                type: 'Large',
                fileUrl: '/models/element-furniture.glb',
                objectName: 'TOP_RECTANGLE',
                objectNameDupont: 'LEAVE_OGEE',
                objectNameWavy: 'LEAVE_WAVY_EDGE',
                importDimensionUnit: 'inch',
                label: 'Large Leaf',
                length: 24,
                minTopLength: null,
                pricing: {
                    price: 894
                },
                purchasableAmounts: [
                    1,
                    2
                ]
            },
            Perimeter: {
                type: 'Perimeter',
                fileUrl: '/models/element-furniture.glb',
                objectName: 'LEAVE_PEREMITER',
                importDimensionUnit: 'inch',
                label: 'Perimeter Leaf',
                length: 12,
                minTopLength: 42,
                sizing: {
                    innerDiameter: {
                        scaleZero: 32,
                        scaleOne: 42
                    },
                    outerDiameter: {
                        scaleZero: 64,
                        scaleOne: 120
                    },
                    thickness: {
                        scaleZero: 0.5,
                        scaleOne: 2.5
                    }
                },
                pricing: {
                    price: 1880
                },
                purchasableAmounts: [
                    1
                ]
            },
            StandardDropIn: {
                type: 'StandardDropIn',
                fileUrl: '/models/element-furniture.glb',
                objectName: 'TOP_RECTANGLE',
                objectNameDupont: 'LEAVE_OGEE',
                objectNameWavy: 'LEAVE_WAVY_EDGE',
                importDimensionUnit: 'inch',
                label: 'Standard Drop-In Leaf',
                length: 12,
                minTopLength: 42,
                pricing: {
                    price: 1003
                },
                purchasableAmounts: [
                    1,
                    2
                ]
            },
            MediumDropIn: {
                type: 'MediumDropIn',
                fileUrl: '/models/element-furniture.glb',
                objectName: 'TOP_RECTANGLE',
                objectNameDupont: 'LEAVE_OGEE',
                objectNameWavy: 'LEAVE_WAVY_EDGE',
                importDimensionUnit: 'inch',
                label: 'Medium Drop-In Leaf',
                length: 18,
                minTopLength: 42,
                pricing: {
                    price: 1073
                },
                purchasableAmounts: [
                    1,
                    2
                ]
            },
            LargeDropIn: {
                type: 'LargeDropIn',
                fileUrl: '/models/element-furniture.glb',
                objectName: 'TOP_RECTANGLE',
                objectNameDupont: 'LEAVE_OGEE',
                objectNameWavy: 'LEAVE_WAVY_EDGE',
                importDimensionUnit: 'inch',
                label: 'Large Drop-In Leaf',
                length: 24,
                minTopLength: 42,
                pricing: {
                    price: 1144
                },
                purchasableAmounts: [
                    1,
                    2
                ]
            },
            CustomLeaf: {
                type: 'CustomLeaf',
                fileUrl: '/models/element-furniture.glb',
                objectName: 'TOP_RECTANGLE',
                objectNameDupont: 'LEAVE_OGEE',
                objectNameWavy: 'LEAVE_WAVY_EDGE',
                importDimensionUnit: 'inch',
                label: 'Custom Leaf',
                length: 0,
                minTopLength: null,
                pricing: {
                    price: 0
                },
                purchasableAmounts: [
                    1,
                    2
                ]
            }
        },
        $modelDataMap: {
            WavyLeaf: {
                width: {
                    scaleZero: 32,
                    scaleOne: 52
                },
                length: {
                    scaleZero: 10,
                    scaleOne: 20
                },
                thickness: {
                    scaleZero: 0.5,
                    scaleOne: 2.5
                }
            },
            DupontLeaf: {
                width: {
                    scaleZero: 32,
                    scaleOne: 52
                },
                length: {
                    scaleZero: 10,
                    scaleOne: 20
                },
                thickness: {
                    scaleZero: 1.75,
                    scaleOne: 2.75
                }
            },
            DupontTop: {
                thickness: {
                    scaleZero: 1.75,
                    scaleOne: 2.75
                }
            }
        }
    }
};
const ApronBasicExpressions = [
    '$repeatX',
    '$repeatY',
    '$materialRoughness',
    '$materialMetalness',
    '$materialEnvMapIntensity',
    '$materialSpecularIntensity',
    '$materialNormalScale',
    '$materialReflectivity',
    '$beveledEdgeConsideration',
    '$apronFilter',
    '$fileUrl',
    '$objectName',
    '$offsetY',
    '$length',
    '$lengthScaleZero',
    '$lengthScaleOne',
    '$width',
    '$widthScaleZero',
    '$widthScaleOne',
    '$thickness',
    '$thicknessScaleZero',
    '$thicknessScaleOne',
    '$stretch',
    '$stretchScaleZero',
    '$stretchScaleOne',
    '$finishColor',
    '$textureUrl',
    '$normalMapUrl',
    '$roughnessMapUrl',
    '$aoMapUrl',
    '$apronThickness',
    '$insetFromEdge',
    '$apronThicknessWithFourLegs',
    '$insetFromEdgeWithFourLegs',
    '$apronDataMap'
];
const BaseDoubleLegExpressions = [
    '$feetThickness',
    '$baseThickness',
    '$singleLegAlternative',
    '$baseWidthMultiplier',
    '$width',
    '$centerWidth',
    '$activeScaleIncrement',
    '$crossbraceType',
    '$visibleCenter',
    '$needTwoCrossbraces',
    '$fileUrl',
    '$objectName',
    '$centerObjectName',
    '$crossbraceObjectName',
    '$offsetZLeft',
    '$widthShapekeyValue',
    '$widthScaleZero',
    '$widthScaleOne',
    '$scaleShapekeyValue',
    '$scaleScaleZero',
    '$scaleScaleOne',
    '$offsetZRight',
    '$centerWidthShapekeyValue',
    '$centerWidthScaleZero',
    '$centerWidthScaleOne',
    '$centerScaleShapekeyValue',
    '$centerScaleScaleZero',
    '$centerScaleScaleOne',
    '$crossbraceOffsetY',
    '$crossbraceOffsetZ',
    '$crossbraceWidthShapekeyValue',
    '$crossbraceWidthScaleZero',
    '$crossbraceWidthScaleOne',
    '$crossbraceLengthShapekeyValue',
    '$crossbraceLengthScaleZero',
    '$crossbraceLengthScaleOne',
    '$crossbraceHeightShapekeyValue',
    '$crossbraceHeightScaleZero',
    '$crossbraceHeightScaleOne',
    '$crossbraceScaleShapekeyValue',
    '$crossbraceScaleScaleZero',
    '$crossbraceScaleScaleOne',
    '$crossbraceSecondaryOffsetZ',
    '$finishColor',
    '$textureUrl',
    '$normalMapUrl',
    '$roughnessMapUrl',
    '$aoMapUrl',
    '$materialRoughness',
    '$materialMetalness',
    '$materialEnvMapIntensity',
    '$materialSpecularIntensity',
    '$materialNormalScale',
    '$materialReflectivity',
    '$repeatX',
    '$repeatY',
    '$crossbraceFinishColor',
    '$crossbraceTextureUrl',
    '$crossbraceNormalMapUrl',
    '$crossbraceRoughnessMapUrl',
    '$crossbraceAoMapUrl',
    '$crossbraceRoughness',
    '$crossbraceMetalness',
    '$crossbraceEnvMapIntensity',
    '$crossbraceSpecularIntensity',
    '$crossbraceNormalScale',
    '$crossbraceReflectivity',
    '$crossbraceRepeatX',
    '$crossbraceRepeatY',
    '$feetThicknessIndicatorFixedX',
    '$feetThicknessIndicatorStartZ',
    '$feetThicknessIndicatorEndZ',
    '$baseThicknessIndicatorVisible',
    '$baseThicknessIndicatorFixedY',
    '$baseThicknessIndicatorStartZ',
    '$baseThicknessIndicatorEndZ',
    '$baseThicknessIndicatorExtrusionX',
    '$scaleLowerBreakpoint',
    '$scaleUpperBreakpoint',
    '$defaultCrossbraceObjectName',
    '$crossbraceDataMap'
];
const BaseFourLegExpressions = [
    '$beveledEdgeConsideration',
    '$widthIndicatorFixedY',
    '$widthIndicatorFixedZ',
    '$widthIndicatorExtrusionZ'
];
const BaseFourLegSeparateExpressions = [
    '$width',
    '$length',
    '$legWidth',
    '$dropInLeafAdditionalOffset',
    '$fileUrl',
    '$objectName',
    '$offsetXTopLeft',
    '$offsetZTopLeft',
    '$height',
    '$heightScaleZero',
    '$heightScaleOne',
    '$offsetXBottomLeft',
    '$offsetZBottomLeft',
    '$offsetXTopRight',
    '$offsetZTopRight',
    '$offsetXBottomRight',
    '$offsetZBottomRight',
    '$finishColor',
    '$textureUrl',
    '$normalMapUrl',
    '$roughnessMapUrl',
    '$aoMapUrl',
    '$materialRoughness',
    '$materialMetalness',
    '$materialEnvMapIntensity',
    '$materialSpecularIntensity',
    '$materialNormalScale',
    '$materialReflectivity',
    '$separateLegRepeatX',
    '$separateLegRepeatY'
];
const BaseSingleLegExpressions = [
    '$baseWidthMultiplier',
    '$baseLengthMultiplier',
    '$activeScaleIncrement',
    '$width',
    '$length',
    '$feetThickness',
    '$baseThickness',
    '$fileUrl',
    '$objectName',
    '$platformFilter',
    '$platformObjectName',
    '$offsetY',
    '$widthShapekeyValue',
    '$widthScaleZero',
    '$widthScaleOne',
    '$lengthShapekeyValue',
    '$lengthScaleZero',
    '$lengthScaleOne',
    '$scaleShapekeyValue',
    '$scaleScaleZero',
    '$scaleScaleOne',
    '$platformWidth',
    '$platformWidthScaleZero',
    '$platformWidthScaleOne',
    '$platformLength',
    '$platformLengthScaleZero',
    '$platformLengthScaleOne',
    '$finishColor',
    '$textureUrl',
    '$normalMapUrl',
    '$roughnessMapUrl',
    '$aoMapUrl',
    '$materialRoughness',
    '$materialMetalness',
    '$materialEnvMapIntensity',
    '$materialSpecularIntensity',
    '$materialNormalScale',
    '$materialReflectivity',
    '$platformRepeatX',
    '$platformRepeatY',
    '$feetThicknessIndicatorVisible',
    '$feetThicknessIndicatorFixedX',
    '$feetThicknessIndicatorStartZ',
    '$feetThicknessIndicatorEndZ',
    '$baseThicknessIndicatorVisible',
    '$baseThicknessIndicatorFixedY',
    '$baseThicknessIndicatorStartZ',
    '$baseThicknessIndicatorEndZ',
    '$baseThicknessIndicatorExtrusionX',
    '$platformWidthIndicatorVisible',
    '$platformWidthIndicatorStartX',
    '$platformWidthIndicatorEndX',
    '$platformWidthIndicatorExtrusionZ',
    '$platformLengthIndicatorVisible',
    '$platformLengthIndicatorStartZ',
    '$platformLengthIndicatorEndZ',
    '$platformLengthIndicatorExtrusionX',
    '$platformHeight',
    '$platformToTopRatio',
    '$scaleLowerBreakpoint',
    '$scaleUpperBreakpoint',
    '$defaultTopWidthForSingleLeg',
    '$defaultTopLengthForSingleLeg',
    '$platformDataMap'
];
const BaseExpressions = [
    '$fileUrl',
    '$objectName',
    '$height',
    '$price',
    '$supportsCrossBrace',
    '$customProductBaseDescription',
    '$repeatX',
    '$repeatY',
    '$materialRoughness',
    '$materialMetalness',
    '$materialEnvMapIntensity',
    '$materialSpecularIntensity',
    '$materialNormalScale',
    '$materialReflectivity',
    '$widthIndicatorVisible',
    '$widthIndicatorStartX',
    '$widthIndicatorFixedY',
    '$widthIndicatorFixedZ',
    '$widthIndicatorEndX',
    '$widthIndicatorExtrusionZ',
    '$finishColor',
    '$textureUrl',
    '$normalMapUrl',
    '$roughnessMapUrl',
    '$aoMapUrl',
    '$table',
    '$topWidthLowerLimitForBaseWidth',
    '$metalRepeatRatio',
    '$defaultHeight',
    '$defaultHeightWithPlatform',
    '$breakpointScaleIncrement',
    '$baseDataMap'
];
const BenchBasicExpressions = [
    '$benchLegScale',
    '$benchCenterLegScale',
    '$benchBaseHeight',
    '$isFourLegSeparateBase',
    '$isFourLegCombinedBase',
    '$isReflectionBase',
    '$woodMaterialRoughness',
    '$woodMaterialMetalness',
    '$woodMaterialEnvMapIntensity',
    '$woodMaterialSpecularIntensity',
    '$woodMaterialNormalScale',
    '$woodMaterialReflectivity',
    '$baseMaterialRoughness',
    '$baseMaterialMetalness',
    '$baseMaterialEnvMapIntensity',
    '$baseMaterialSpecularIntensity',
    '$baseMaterialNormalScale',
    '$baseMaterialReflectivity',
    '$benchCrossbraceType',
    '$benchNeedTwoCrossbraces',
    '$benchLegScaleY',
    '$benchNearVisible',
    '$fileUrl',
    '$benchTopObjectName',
    '$benchNearApronVisible',
    '$benchNearDoubleLegVisible',
    '$benchBaseObjectName',
    '$benchNearCenterLegVisible',
    '$benchCenterBaseObjectName',
    '$benchFarVisible',
    '$benchFarApronVisible',
    '$benchFarDoubleLegVisible',
    '$benchFarCenterLegVisible',
    '$benchNearFourLegVisible',
    '$benchFourLegObjectName',
    '$benchFarFourLegVisible',
    '$benchNearFourLegCombinedVisible',
    '$benchFarFourLegCombinedVisible',
    '$benchNearReflectionVisible',
    '$benchFarReflectionVisible',
    '$benchNearCrossbraceVisible',
    '$benchCrossbraceObjectName',
    '$benchNearCrossbraceSecondaryVisible',
    '$benchFarCrossbraceVisible',
    '$benchFarCrossbraceSecondaryVisible',
    '$benchNearOffsetX',
    '$benchTopOffsetY',
    '$benchTopWidthValue',
    '$benchLength',
    '$benchTopThicknessValue',
    '$benchBevelThickness',
    '$bevelScaleZero',
    '$bevelScaleOne',
    '$benchApronOffsetY',
    '$benchApronWidth',
    '$benchApronLength',
    '$benchApronThicknessValue',
    '$benchLegLeftOffsetZ',
    '$benchLegScaleX',
    '$benchLegScaleZ',
    '$benchBaseFootprintValue',
    '$benchBaseWidthScaleZero',
    '$benchBaseWidthScaleOne',
    '$benchLegRightOffsetZ',
    '$benchCenterLegScaleX',
    '$benchCenterLegScaleZ',
    '$benchCenterBaseFootprintValue',
    '$benchCenterBaseWidthScaleZero',
    '$benchCenterBaseWidthScaleOne',
    '$benchFarOffsetX',
    '$benchCenterLegVisible',
    '$benchNearFourLegOuterOffsetX',
    '$benchFourLegLeftOffsetZ',
    '$benchFourLegScaleX',
    '$benchFourLegScaleY',
    '$benchFourLegScaleZ',
    '$benchFourLegRightOffsetZ',
    '$benchNearFourLegInnerOffsetX',
    '$benchFarFourLegOuterOffsetX',
    '$benchFarFourLegInnerOffsetX',
    '$benchFourLegCombinedWidthScaleZero',
    '$benchFourLegCombinedWidthScaleOne',
    '$benchFourLegCombinedLengthScaleZero',
    '$benchFourLegCombinedLengthScaleOne',
    '$benchReflectionScaleX',
    '$benchReflectionScaleY',
    '$benchReflectionScaleZ',
    '$benchReflectionLength',
    '$benchReflectionLengthScaleZero',
    '$benchReflectionLengthScaleOne',
    '$benchCrossbraceOffsetY',
    '$benchCrossbraceOffsetZ',
    '$benchCrossbraceWidthShapekeyValue',
    '$benchCrossbraceWidthScaleZero',
    '$benchCrossbraceWidthScaleOne',
    '$benchCrossbraceLengthShapekeyValue',
    '$benchCrossbraceLengthScaleZero',
    '$benchCrossbraceLengthScaleOne',
    '$benchCrossbraceHeightShapekeyValue',
    '$benchCrossbraceHeightScaleZero',
    '$benchCrossbraceHeightScaleOne',
    '$benchCrossbraceScaleShapekeyValue',
    '$benchCrossbraceScaleScaleZero',
    '$benchCrossbraceScaleScaleOne',
    '$benchCrossbraceSecondaryOffsetZ',
    '$topFinishColor',
    '$textureUrl',
    '$normalMapUrl',
    '$roughnessMapUrl',
    '$aoMapUrl',
    '$benchTopRepeatX',
    '$benchTopRepeatY',
    '$benchApronFinishColor',
    '$benchApronRepeatX',
    '$benchApronRepeatY',
    '$baseFinishColor',
    '$baseTextureUrl',
    '$baseNormalMapUrl',
    '$baseRoughnessMapUrl',
    '$baseAoMapUrl',
    '$benchBaseRepeatX',
    '$benchBaseRepeatY',
    '$benchFourLegRepeatX',
    '$benchFourLegRepeatY',
    '$benchCrossbraceFinishColor',
    '$benchCrossbraceTextureUrl',
    '$benchCrossbraceNormalMapUrl',
    '$benchCrossbraceRoughnessMapUrl',
    '$benchCrossbraceAoMapUrl',
    '$benchCrossbraceRoughness',
    '$benchCrossbraceMetalness',
    '$benchCrossbraceEnvMapIntensity',
    '$benchCrossbraceSpecularIntensity',
    '$benchCrossbraceNormalScale',
    '$benchCrossbraceReflectivity',
    '$benchCrossbraceRepeatX',
    '$benchCrossbraceRepeatY',
    '$benchEdgeNormalMapUrl',
    '$benchEdgeNormalScale',
    '$benchEdgeRepeatX',
    '$benchEdgeRepeatY',
    '$benchNearLengthDimIndFixedX',
    '$benchDimIndFixedY',
    '$benchNearLengthDimIndStartZ',
    '$benchNearLengthDimIndEndZ',
    '$benchNearWidthDimIndStartX',
    '$benchNearWidthDimIndFixedZ',
    '$benchNearWidthDimIndEndX',
    '$benchFarLengthDimIndFixedX',
    '$benchFarLengthDimIndStartZ',
    '$benchFarLengthDimIndEndZ',
    '$benchFarWidthDimIndStartX',
    '$benchFarWidthDimIndFixedZ',
    '$benchFarWidthDimIndEndX',
    '$benchHeight',
    '$benchTopThickness',
    '$benchTopWidth',
    '$benchBaseFootprint',
    '$benchInsetFromTable',
    '$benchApronThickness',
    '$benchApronInset',
    '$benchGap',
    '$benchLegInsetDefault',
    '$crossbraceDataMap'
];
const RootEntityExpressions = [
    '$customProductTitle',
    '$customProductDescription',
    '$accessoriesDescriptionHTML',
    '$materialAndFinishesDescriptionHTML',
    '$glbFileUrl',
    '$emailSubject',
    '$emailBodyText',
    '$emailFooterNote',
    '$emailFooterAddress',
    '$emailFooterPhone',
    '$emailFooterEmail',
    '$tableColumns'
];
const TableExpressions = [
    '$pricingConfig',
    '$fullWidth',
    '$fullLength',
    '$woodTextureSize',
    '$apronIsMandatory',
    '$thicknessPrice',
    '$edgeStylePrice',
    '$leafPrice',
    '$apronPrice',
    '$seatingPrice',
    '$distressPrice',
    '$topFinishPrice',
    '$baseFinishPrice',
    '$sheenPrice',
    '$groovesPrice',
    '$cornerRadiusPrice',
    '$crossbracePrice',
    '$woodSpeciesRate',
    '$woodPartsTotal',
    '$woodSpeciesPrice',
    '$topSubtotal',
    '$baseSubtotal',
    '$materialsSubtotal',
    '$accessoriesSubtotal',
    '$tableData',
    '$price',
    '$topOptions',
    '$baseStyleOptions',
    '$seatingAmountOptions',
    '$top',
    '$base',
    '$bench',
    '$violations'
];
const TopWithDiameterExpressions = [
    '$defaultDiameter',
    '$offsetY',
    '$thicknessValue',
    '$thicknessScaleZero',
    '$thicknessScaleOne',
    '$widthScaleZero',
    '$widthScaleOne',
    '$lengthScaleZero',
    '$lengthScaleOne',
    '$distance',
    '$distanceScaleZero',
    '$distanceScaleOne',
    '$leafBevel',
    '$leafBevelScaleZero',
    '$leafBevelScaleOne',
    '$bevelThickness',
    '$bevelScaleZero',
    '$bevelScaleOne',
    '$minWidth',
    '$maxWidth'
];
const TopExpressions = [
    '$width',
    '$length',
    '$fileUrl',
    '$objectName',
    '$availableThicknessTypes',
    '$availableBaseStyles',
    '$availableLeafTypes',
    '$sizeDescription',
    '$price',
    '$customProductTopDescription',
    '$topDimensionsHTML',
    '$defaultWidth',
    '$defaultLength',
    '$materialRoughness',
    '$materialMetalness',
    '$materialEnvMapIntensity',
    '$materialSpecularIntensity',
    '$materialNormalScale',
    '$materialReflectivity',
    '$withBevel',
    '$leafWidth',
    '$leafLength',
    '$leafThickness',
    '$bevelThicknessValue',
    '$apronOptions',
    '$minThickness',
    '$maxThickness',
    '$leafLeftVisible',
    '$leafObjectName',
    '$leafRightVisible',
    '$leafCenterVisible',
    '$leafCenter2Visible',
    '$leafPerimeterVisible',
    '$leafPerimeterObjectName',
    '$offsetY',
    '$leafLeftOffsetZ',
    '$leafLeftRotationY',
    '$leafLengthShapekeyValue',
    '$leafLengthScaleZero',
    '$leafLengthScaleOne',
    '$leafWidthShapekeyValue',
    '$leafWidthScaleZero',
    '$leafWidthScaleOne',
    '$leafThicknessShapekeyValue',
    '$leafThicknessScaleOne',
    '$leafThicknessScaleZero',
    '$leafDupontEdgeOnSideValue',
    '$leafWavyEdgeOnSideValue',
    '$bevelThickness',
    '$bevelScaleZero',
    '$bevelScaleOne',
    '$leafRightOffsetZ',
    '$leafRightRotationY',
    '$leafCenterOffsetY',
    '$leafCenterOffsetZ',
    '$leafCenterRotationY',
    '$leafCenter2OffsetZ',
    '$leafCenter2RotationY',
    '$leafPerimeterOffsetY',
    '$leafPerimeterInnerDiameter',
    '$leafPerimeterInnerDiameterScaleZero',
    '$leafPerimeterInnerDiameterScaleOne',
    '$leafPerimeterOuterDiameter',
    '$leafPerimeterOuterDiameterScaleZero',
    '$leafPerimeterOuterDiameterScaleOne',
    '$leafPerimeterThickness',
    '$leafPerimeterThicknessScaleOne',
    '$leafPerimeterThicknessScaleZero',
    '$thicknessTypeOptions',
    '$leafTypeOptions',
    '$leafAmountOptions',
    '$finishColor',
    '$textureUrl',
    '$textureOffsetX',
    '$normalMapUrl',
    '$distressBumpMapUrl',
    '$distressBumpScale',
    '$roughnessMapUrl',
    '$aoMapUrl',
    '$repeatX',
    '$repeatY',
    '$leafRepeatX',
    '$leafRepeatY',
    '$leafPerimeterRepeatX',
    '$leafPerimeterRepeatY',
    '$edgeNormalMapUrl',
    '$edgeNormalScale',
    '$edgeRepeatX',
    '$edgeRepeatY',
    '$topIndicatorXVisible',
    '$topIndicatorXStartX',
    '$topIndicatorXFixedY',
    '$topIndicatorXFixedZ',
    '$topIndicatorXEndX',
    '$topDimensionIndicatorZVisible',
    '$topIndicatorZFixedX',
    '$topIndicatorZFixedY',
    '$topIndicatorZStartZ',
    '$topIndicatorZEndZ',
    '$shapeIndicatorXStartX',
    '$shapeIndicatorXFixedY',
    '$shapeIndicatorXFixedZ',
    '$shapeIndicatorXEndX',
    '$shapeDimensionIndicatorXExtrusionZ',
    '$shapeDimensionIndicatorZVisible',
    '$shapeIndicatorZFixedX',
    '$shapeIndicatorZFixedY',
    '$shapeIndicatorZStartZ',
    '$shapeIndicatorZEndZ',
    '$shapeDimensionIndicatorZExtrusionX',
    '$splitTableIndicatorZVisible',
    '$splitTableLeftIndicatorZFixedX',
    '$splitTableLeftIndicatorZFixedY',
    '$splitTableLeftIndicatorZStartZ',
    '$splitTableLeftIndicatorZEndZ',
    '$splitTableLeftDimensionIndicatorZExtrusionX',
    '$splitTableRightIndicatorZFixedX',
    '$splitTableRightIndicatorZFixedY',
    '$splitTableRightIndicatorZStartZ',
    '$splitTableRightIndicatorZEndZ',
    '$splitTableRightDimensionIndicatorZExtrusionX',
    '$leafLeftIndicatorZFixedX',
    '$leafLeftIndicatorZFixedY',
    '$leafLeftIndicatorZStartZ',
    '$leafLeftIndicatorZEndZ',
    '$leafRightIndicatorZFixedX',
    '$leafRightIndicatorZFixedY',
    '$leafRightIndicatorZStartZ',
    '$leafRightIndicatorZEndZ',
    '$leafCenterIndicatorZFixedX',
    '$leafCenterIndicatorZFixedY',
    '$leafCenterIndicatorZStartZ',
    '$leafCenterIndicatorZEndZ',
    '$leafCenter2IndicatorZFixedX',
    '$leafCenter2IndicatorZFixedY',
    '$leafCenter2IndicatorZStartZ',
    '$leafCenter2IndicatorZEndZ',
    '$table',
    '$apron',
    '$minLeafAmount',
    '$minTopLengthForExtraBase',
    '$minTopLengthForDoubleBase',
    '$straightPartOfBevelTopThickness',
    '$minBeveledTopThickness',
    '$topDataMap',
    '$leafDataMap',
    '$modelDataMap'
];
const BaseFourLegCombinedExpressions = [
    '$fileUrl',
    '$objectName',
    '$width',
    '$widthScaleZero',
    '$widthScaleOne',
    '$length',
    '$lengthScaleZero',
    '$lengthScaleOne'
];
const TopWithSideExpressions = [
    '$offsetY',
    '$thicknessValue',
    '$thicknessScaleZero',
    '$thicknessScaleOne',
    '$widthScaleZero',
    '$widthScaleOne',
    '$lengthScaleZero',
    '$lengthScaleOne',
    '$distance',
    '$distanceScaleZero',
    '$distanceScaleOne',
    '$leafBevel',
    '$leafBevelScaleZero',
    '$leafBevelScaleOne',
    '$bevelThickness',
    '$bevelScaleZero',
    '$bevelScaleOne',
    '$minWidth',
    '$maxWidth'
];
const TopWithWidthAndLengthExpressions = [
    '$offsetY',
    '$thicknessValue',
    '$thicknessScaleZero',
    '$thicknessScaleOne',
    '$widthScaleZero',
    '$widthScaleOne',
    '$lengthScaleZero',
    '$lengthScaleOne',
    '$distance',
    '$distanceScaleZero',
    '$distanceScaleOne',
    '$leafBevel',
    '$leafBevelScaleZero',
    '$leafBevelScaleOne',
    '$bevelThickness',
    '$bevelScaleZero',
    '$bevelScaleOne',
    '$minWidth',
    '$maxWidth',
    '$minLength',
    '$maxLength'
];
const BenchExpressions = [
    '$table'
];
const ApronExpressions = [
    '$top'
];
const AnchorBaseExpressions = [
    '$violations'
];
const AnchorSingleFeetBaseExpressions = [
    '$violations'
];
const AnchorSinglePlatformBaseExpressions = [
    '$violations'
];
const BellhouseBaseExpressions = [
    '$violations'
];
const BellhouseSingleFeetBaseExpressions = [
    '$violations'
];
const BellhouseSinglePlatformBaseExpressions = [
    '$violations'
];
const BellyStretchedBaseExpressions = [
    '$violations'
];
const BrewerBaseExpressions = [
    '$violations'
];
const BrewerSingleBaseExpressions = [
    '$violations'
];
const CaseyBaseExpressions = [
    '$violations'
];
const CraftsmanBaseExpressions = [
    '$violations'
];
const CraftsmanSingleBaseExpressions = [
    '$violations'
];
const CrescentBaseExpressions = [
    '$violations'
];
const CrescentSingleBaseExpressions = [
    '$violations'
];
const DanaBaseExpressions = [
    '$violations'
];
const DanaSingleBaseExpressions = [
    '$violations'
];
const FranklinBaseExpressions = [
    '$violations'
];
const FranklinSingleFeetBaseExpressions = [
    '$violations'
];
const FranklinSinglePlatformBaseExpressions = [
    '$violations'
];
const MantisBaseExpressions = [
    '$violations'
];
const MarksBaseExpressions = [
    '$violations'
];
const MeredithBaseExpressions = [
    '$violations'
];
const MeredithSingleFeetBaseExpressions = [
    '$violations'
];
const MeredithSinglePlatformBaseExpressions = [
    '$violations'
];
const OswaldBaseExpressions = [
    '$violations'
];
const OswaldSingleBaseExpressions = [
    '$violations'
];
const PeruStretchedBaseExpressions = [
    '$violations'
];
const RishBaseExpressions = [
    '$violations'
];
const RishSingleBaseExpressions = [
    '$violations'
];
const RogersBaseExpressions = [
    '$violations'
];
const RogersSinglePlatformBaseExpressions = [
    '$violations'
];
const TamaraBaseExpressions = [
    '$violations'
];
const TamaraSingleBaseExpressions = [
    '$violations'
];
const TuscanBaseExpressions = [
    '$violations'
];
const TuscanSingleFeetBaseExpressions = [
    '$violations'
];
const TuscanSinglePlatformBaseExpressions = [
    '$violations'
];
const WaldenBaseExpressions = [
    '$violations'
];
const WaldenSingleBaseExpressions = [
    '$violations'
];
const XBaseExpressions = [
    '$violations'
];
const XSingleBaseExpressions = [
    '$violations'
];
const AnglePictureFrameBaseExpressions = [
    '$violations'
];
const AnglePictureFrameSingleBaseExpressions = [
    '$violations'
];
const AnglePictureFrameCTCBaseExpressions = [
    '$violations'
];
const ArchBaseExpressions = [
    '$violations'
];
const ArchSingleBaseExpressions = [
    '$violations'
];
const BoxFrameBaseExpressions = [
    '$violations'
];
const ConnectedXBaseExpressions = [
    '$violations'
];
const SlimConnectedXBaseExpressions = [
    '$violations'
];
const SlimConnectedXSingleBaseExpressions = [
    '$violations'
];
const ReflectionBaseExpressions = [
    '$violations'
];
const ReflectionCTCBaseExpressions = [
    '$violations'
];
const SinglePostBaseExpressions = [
    '$violations'
];
const SinglePostSingleBaseExpressions = [
    '$violations'
];
const XMetalBaseExpressions = [
    '$violations'
];
const XMetalSingleBaseExpressions = [
    '$violations'
];
const IvyBaseExpressions = [
    '$violations'
];
const DremorTurnedBaseExpressions = [
    '$violations'
];
const HerricksonTurnedBaseExpressions = [
    '$violations'
];
const MidModernTaperBaseExpressions = [
    '$violations'
];
const NarrowEnglishTurnedBaseExpressions = [
    '$violations'
];
const OldEnglishTurnedBaseExpressions = [
    '$violations'
];
const SlagleTurnedBaseExpressions = [
    '$violations'
];
const TraditionalBaseExpressions = [
    '$violations'
];
const TraditionalFlushBaseExpressions = [
    '$violations'
];
const ReededBaseExpressions = [
    '$violations'
];
const HershBaseExpressions = [
    '$violations'
];
const TriflectionBaseExpressions = [
    '$violations'
];
const RectangleTopExpressions = [
    '$violations'
];
const SquareTopExpressions = [
    '$violations'
];
const RoundTopExpressions = [
    '$violations'
];
const EllipticalOvalTopExpressions = [
    '$violations'
];
const RacetrackOvalTopExpressions = [
    '$violations'
];
const BoatShapeTopExpressions = [
    '$violations'
];
export const $Table = new $DomainEntityReflection('Table', [
    ...TableExpressions,
    ...RootEntityExpressions
]);
export const $RectangleTop = new $DomainEntityReflection('RectangleTop', [
    ...RectangleTopExpressions,
    ...TopExpressions,
    ...TopWithWidthAndLengthExpressions
]);
export const $SquareTop = new $DomainEntityReflection('SquareTop', [
    ...SquareTopExpressions,
    ...TopExpressions,
    ...TopWithSideExpressions
]);
export const $RoundTop = new $DomainEntityReflection('RoundTop', [
    ...RoundTopExpressions,
    ...TopExpressions,
    ...TopWithDiameterExpressions
]);
export const $EllipticalOvalTop = new $DomainEntityReflection('EllipticalOvalTop', [
    ...EllipticalOvalTopExpressions,
    ...TopExpressions,
    ...TopWithWidthAndLengthExpressions
]);
export const $RacetrackOvalTop = new $DomainEntityReflection('RacetrackOvalTop', [
    ...RacetrackOvalTopExpressions,
    ...TopExpressions,
    ...TopWithWidthAndLengthExpressions
]);
export const $BoatShapeTop = new $DomainEntityReflection('BoatShapeTop', [
    ...BoatShapeTopExpressions,
    ...TopExpressions,
    ...TopWithWidthAndLengthExpressions
]);
export const $AnchorBase = new $DomainEntityReflection('AnchorBase', [
    ...AnchorBaseExpressions,
    ...BaseExpressions,
    ...BaseDoubleLegExpressions
]);
export const $AnchorSingleFeetBase = new $DomainEntityReflection('AnchorSingleFeetBase', [
    ...AnchorSingleFeetBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions
]);
export const $AnchorSinglePlatformBase = new $DomainEntityReflection('AnchorSinglePlatformBase', [
    ...AnchorSinglePlatformBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions
]);
export const $BellhouseBase = new $DomainEntityReflection('BellhouseBase', [
    ...BellhouseBaseExpressions,
    ...BaseExpressions,
    ...BaseDoubleLegExpressions
]);
export const $BellhouseSingleFeetBase = new $DomainEntityReflection('BellhouseSingleFeetBase', [
    ...BellhouseSingleFeetBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions
]);
export const $BellhouseSinglePlatformBase = new $DomainEntityReflection('BellhouseSinglePlatformBase', [
    ...BellhouseSinglePlatformBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions
]);
export const $BellyStretchedBase = new $DomainEntityReflection('BellyStretchedBase', [
    ...BellyStretchedBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions
]);
export const $BrewerBase = new $DomainEntityReflection('BrewerBase', [
    ...BrewerBaseExpressions,
    ...BaseExpressions,
    ...BaseDoubleLegExpressions
]);
export const $BrewerSingleBase = new $DomainEntityReflection('BrewerSingleBase', [
    ...BrewerSingleBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions
]);
export const $CaseyBase = new $DomainEntityReflection('CaseyBase', [
    ...CaseyBaseExpressions,
    ...BaseExpressions,
    ...BaseDoubleLegExpressions
]);
export const $CraftsmanBase = new $DomainEntityReflection('CraftsmanBase', [
    ...CraftsmanBaseExpressions,
    ...BaseExpressions,
    ...BaseDoubleLegExpressions
]);
export const $CraftsmanSingleBase = new $DomainEntityReflection('CraftsmanSingleBase', [
    ...CraftsmanSingleBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions
]);
export const $CrescentBase = new $DomainEntityReflection('CrescentBase', [
    ...CrescentBaseExpressions,
    ...BaseExpressions,
    ...BaseDoubleLegExpressions
]);
export const $CrescentSingleBase = new $DomainEntityReflection('CrescentSingleBase', [
    ...CrescentSingleBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions
]);
export const $DanaBase = new $DomainEntityReflection('DanaBase', [
    ...DanaBaseExpressions,
    ...BaseExpressions,
    ...BaseDoubleLegExpressions
]);
export const $DanaSingleBase = new $DomainEntityReflection('DanaSingleBase', [
    ...DanaSingleBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions
]);
export const $FranklinBase = new $DomainEntityReflection('FranklinBase', [
    ...FranklinBaseExpressions,
    ...BaseExpressions,
    ...BaseDoubleLegExpressions
]);
export const $FranklinSingleFeetBase = new $DomainEntityReflection('FranklinSingleFeetBase', [
    ...FranklinSingleFeetBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions
]);
export const $FranklinSinglePlatformBase = new $DomainEntityReflection('FranklinSinglePlatformBase', [
    ...FranklinSinglePlatformBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions
]);
export const $MantisBase = new $DomainEntityReflection('MantisBase', [
    ...MantisBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions
]);
export const $MarksBase = new $DomainEntityReflection('MarksBase', [
    ...MarksBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions
]);
export const $MeredithBase = new $DomainEntityReflection('MeredithBase', [
    ...MeredithBaseExpressions,
    ...BaseExpressions,
    ...BaseDoubleLegExpressions
]);
export const $MeredithSingleFeetBase = new $DomainEntityReflection('MeredithSingleFeetBase', [
    ...MeredithSingleFeetBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions
]);
export const $MeredithSinglePlatformBase = new $DomainEntityReflection('MeredithSinglePlatformBase', [
    ...MeredithSinglePlatformBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions
]);
export const $OswaldBase = new $DomainEntityReflection('OswaldBase', [
    ...OswaldBaseExpressions,
    ...BaseExpressions,
    ...BaseDoubleLegExpressions
]);
export const $OswaldSingleBase = new $DomainEntityReflection('OswaldSingleBase', [
    ...OswaldSingleBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions
]);
export const $PeruStretchedBase = new $DomainEntityReflection('PeruStretchedBase', [
    ...PeruStretchedBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions
]);
export const $RishBase = new $DomainEntityReflection('RishBase', [
    ...RishBaseExpressions,
    ...BaseExpressions,
    ...BaseDoubleLegExpressions
]);
export const $RishSingleBase = new $DomainEntityReflection('RishSingleBase', [
    ...RishSingleBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions
]);
export const $RogersBase = new $DomainEntityReflection('RogersBase', [
    ...RogersBaseExpressions,
    ...BaseExpressions,
    ...BaseDoubleLegExpressions
]);
export const $RogersSinglePlatformBase = new $DomainEntityReflection('RogersSinglePlatformBase', [
    ...RogersSinglePlatformBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions
]);
export const $TamaraBase = new $DomainEntityReflection('TamaraBase', [
    ...TamaraBaseExpressions,
    ...BaseExpressions,
    ...BaseDoubleLegExpressions
]);
export const $TamaraSingleBase = new $DomainEntityReflection('TamaraSingleBase', [
    ...TamaraSingleBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions
]);
export const $TuscanBase = new $DomainEntityReflection('TuscanBase', [
    ...TuscanBaseExpressions,
    ...BaseExpressions,
    ...BaseDoubleLegExpressions
]);
export const $TuscanSingleFeetBase = new $DomainEntityReflection('TuscanSingleFeetBase', [
    ...TuscanSingleFeetBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions
]);
export const $TuscanSinglePlatformBase = new $DomainEntityReflection('TuscanSinglePlatformBase', [
    ...TuscanSinglePlatformBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions
]);
export const $WaldenBase = new $DomainEntityReflection('WaldenBase', [
    ...WaldenBaseExpressions,
    ...BaseExpressions,
    ...BaseDoubleLegExpressions
]);
export const $WaldenSingleBase = new $DomainEntityReflection('WaldenSingleBase', [
    ...WaldenSingleBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions
]);
export const $AnglePictureFrameBase = new $DomainEntityReflection('AnglePictureFrameBase', [
    ...AnglePictureFrameBaseExpressions,
    ...BaseExpressions,
    ...BaseDoubleLegExpressions
]);
export const $XBase = new $DomainEntityReflection('XBase', [
    ...XBaseExpressions,
    ...BaseExpressions,
    ...BaseDoubleLegExpressions
]);
export const $XSingleBase = new $DomainEntityReflection('XSingleBase', [
    ...XSingleBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions
]);
export const $AnglePictureFrameSingleBase = new $DomainEntityReflection('AnglePictureFrameSingleBase', [
    ...AnglePictureFrameSingleBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions
]);
export const $AnglePictureFrameCTCBase = new $DomainEntityReflection('AnglePictureFrameCTCBase', [
    ...AnglePictureFrameCTCBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions
]);
export const $ArchBase = new $DomainEntityReflection('ArchBase', [
    ...ArchBaseExpressions,
    ...BaseExpressions,
    ...BaseDoubleLegExpressions
]);
export const $ArchSingleBase = new $DomainEntityReflection('ArchSingleBase', [
    ...ArchSingleBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions
]);
export const $BoxFrameBase = new $DomainEntityReflection('BoxFrameBase', [
    ...BoxFrameBaseExpressions,
    ...BaseExpressions,
    ...BaseDoubleLegExpressions
]);
export const $ConnectedXBase = new $DomainEntityReflection('ConnectedXBase', [
    ...ConnectedXBaseExpressions,
    ...BaseExpressions,
    ...BaseDoubleLegExpressions
]);
export const $SlimConnectedXBase = new $DomainEntityReflection('SlimConnectedXBase', [
    ...SlimConnectedXBaseExpressions,
    ...BaseExpressions,
    ...BaseDoubleLegExpressions
]);
export const $SlimConnectedXSingleBase = new $DomainEntityReflection('SlimConnectedXSingleBase', [
    ...SlimConnectedXSingleBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions
]);
export const $ReflectionBase = new $DomainEntityReflection('ReflectionBase', [
    ...ReflectionBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions
]);
export const $ReflectionCTCBase = new $DomainEntityReflection('ReflectionCTCBase', [
    ...ReflectionCTCBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions
]);
export const $SinglePostBase = new $DomainEntityReflection('SinglePostBase', [
    ...SinglePostBaseExpressions,
    ...BaseExpressions,
    ...BaseDoubleLegExpressions
]);
export const $SinglePostSingleBase = new $DomainEntityReflection('SinglePostSingleBase', [
    ...SinglePostSingleBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions
]);
export const $XMetalBase = new $DomainEntityReflection('XMetalBase', [
    ...XMetalBaseExpressions,
    ...BaseExpressions,
    ...BaseDoubleLegExpressions
]);
export const $XMetalSingleBase = new $DomainEntityReflection('XMetalSingleBase', [
    ...XMetalSingleBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions
]);
export const $IvyBase = new $DomainEntityReflection('IvyBase', [
    ...IvyBaseExpressions,
    ...BaseExpressions,
    ...BaseFourLegExpressions,
    ...BaseFourLegCombinedExpressions
]);
export const $DremorTurnedBase = new $DomainEntityReflection('DremorTurnedBase', [
    ...DremorTurnedBaseExpressions,
    ...BaseExpressions,
    ...BaseFourLegExpressions,
    ...BaseFourLegSeparateExpressions
]);
export const $HerricksonTurnedBase = new $DomainEntityReflection('HerricksonTurnedBase', [
    ...HerricksonTurnedBaseExpressions,
    ...BaseExpressions,
    ...BaseFourLegExpressions,
    ...BaseFourLegSeparateExpressions
]);
export const $MidModernTaperBase = new $DomainEntityReflection('MidModernTaperBase', [
    ...MidModernTaperBaseExpressions,
    ...BaseExpressions,
    ...BaseFourLegExpressions,
    ...BaseFourLegSeparateExpressions
]);
export const $NarrowEnglishTurnedBase = new $DomainEntityReflection('NarrowEnglishTurnedBase', [
    ...NarrowEnglishTurnedBaseExpressions,
    ...BaseExpressions,
    ...BaseFourLegExpressions,
    ...BaseFourLegSeparateExpressions
]);
export const $OldEnglishTurnedBase = new $DomainEntityReflection('OldEnglishTurnedBase', [
    ...OldEnglishTurnedBaseExpressions,
    ...BaseExpressions,
    ...BaseFourLegExpressions,
    ...BaseFourLegSeparateExpressions
]);
export const $SlagleTurnedBase = new $DomainEntityReflection('SlagleTurnedBase', [
    ...SlagleTurnedBaseExpressions,
    ...BaseExpressions,
    ...BaseFourLegExpressions,
    ...BaseFourLegSeparateExpressions
]);
export const $TraditionalBase = new $DomainEntityReflection('TraditionalBase', [
    ...TraditionalBaseExpressions,
    ...BaseExpressions,
    ...BaseFourLegExpressions,
    ...BaseFourLegSeparateExpressions
]);
export const $TraditionalFlushBase = new $DomainEntityReflection('TraditionalFlushBase', [
    ...TraditionalFlushBaseExpressions,
    ...BaseExpressions,
    ...BaseFourLegExpressions,
    ...BaseFourLegSeparateExpressions
]);
export const $ReededBase = new $DomainEntityReflection('ReededBase', [
    ...ReededBaseExpressions,
    ...BaseExpressions,
    ...BaseSingleLegExpressions
]);
export const $HershBase = new $DomainEntityReflection('HershBase', [
    ...HershBaseExpressions,
    ...BaseExpressions,
    ...BaseDoubleLegExpressions
]);
export const $TriflectionBase = new $DomainEntityReflection('TriflectionBase', [
    ...TriflectionBaseExpressions,
    ...BaseExpressions,
    ...BaseDoubleLegExpressions
]);
export const $ApronBasic = new $DomainEntityReflection('ApronBasic', [
    ...ApronBasicExpressions,
    ...ApronExpressions
]);
export const $ApronNone = new $DomainEntityReflection('ApronNone', [
    ...ApronExpressions
]);
export const $BenchBasic = new $DomainEntityReflection('BenchBasic', [
    ...BenchBasicExpressions,
    ...BenchExpressions
]);
export const $AnyDomainEntity = new EnhancedAliasReflection('$AnyDomainEntity', [
    Table.type,
    RectangleTop.type,
    SquareTop.type,
    RoundTop.type,
    EllipticalOvalTop.type,
    RacetrackOvalTop.type,
    BoatShapeTop.type,
    AnchorBase.type,
    AnchorSingleFeetBase.type,
    AnchorSinglePlatformBase.type,
    BellhouseBase.type,
    BellhouseSingleFeetBase.type,
    BellhouseSinglePlatformBase.type,
    BellyStretchedBase.type,
    BrewerBase.type,
    BrewerSingleBase.type,
    CaseyBase.type,
    CraftsmanBase.type,
    CraftsmanSingleBase.type,
    CrescentBase.type,
    CrescentSingleBase.type,
    DanaBase.type,
    DanaSingleBase.type,
    FranklinBase.type,
    FranklinSingleFeetBase.type,
    FranklinSinglePlatformBase.type,
    MantisBase.type,
    MarksBase.type,
    MeredithBase.type,
    MeredithSingleFeetBase.type,
    MeredithSinglePlatformBase.type,
    OswaldBase.type,
    OswaldSingleBase.type,
    PeruStretchedBase.type,
    RishBase.type,
    RishSingleBase.type,
    RogersBase.type,
    RogersSinglePlatformBase.type,
    TamaraBase.type,
    TamaraSingleBase.type,
    TuscanBase.type,
    TuscanSingleFeetBase.type,
    TuscanSinglePlatformBase.type,
    WaldenBase.type,
    WaldenSingleBase.type,
    AnglePictureFrameBase.type,
    XBase.type,
    XSingleBase.type,
    AnglePictureFrameSingleBase.type,
    AnglePictureFrameCTCBase.type,
    ArchBase.type,
    ArchSingleBase.type,
    BoxFrameBase.type,
    ConnectedXBase.type,
    SlimConnectedXBase.type,
    SlimConnectedXSingleBase.type,
    ReflectionBase.type,
    ReflectionCTCBase.type,
    SinglePostBase.type,
    SinglePostSingleBase.type,
    XMetalBase.type,
    XMetalSingleBase.type,
    IvyBase.type,
    DremorTurnedBase.type,
    HerricksonTurnedBase.type,
    MidModernTaperBase.type,
    NarrowEnglishTurnedBase.type,
    OldEnglishTurnedBase.type,
    SlagleTurnedBase.type,
    TraditionalBase.type,
    TraditionalFlushBase.type,
    ReededBase.type,
    HershBase.type,
    TriflectionBase.type,
    ApronBasic.type,
    ApronNone.type,
    BenchBasic.type
]);
export const $RootEntity = new EnhancedAliasReflection('$RootEntity', [
    Table.type
]);
export const $Top = new EnhancedAliasReflection('$Top', [
    RectangleTop.type,
    SquareTop.type,
    RoundTop.type,
    EllipticalOvalTop.type,
    RacetrackOvalTop.type,
    BoatShapeTop.type
]);
export const $Base = new EnhancedAliasReflection('$Base', [
    AnchorBase.type,
    AnchorSingleFeetBase.type,
    AnchorSinglePlatformBase.type,
    BellhouseBase.type,
    BellhouseSingleFeetBase.type,
    BellhouseSinglePlatformBase.type,
    BellyStretchedBase.type,
    BrewerBase.type,
    BrewerSingleBase.type,
    CaseyBase.type,
    CraftsmanBase.type,
    CraftsmanSingleBase.type,
    CrescentBase.type,
    CrescentSingleBase.type,
    DanaBase.type,
    DanaSingleBase.type,
    FranklinBase.type,
    FranklinSingleFeetBase.type,
    FranklinSinglePlatformBase.type,
    MantisBase.type,
    MarksBase.type,
    MeredithBase.type,
    MeredithSingleFeetBase.type,
    MeredithSinglePlatformBase.type,
    OswaldBase.type,
    OswaldSingleBase.type,
    PeruStretchedBase.type,
    RishBase.type,
    RishSingleBase.type,
    RogersBase.type,
    RogersSinglePlatformBase.type,
    TamaraBase.type,
    TamaraSingleBase.type,
    TuscanBase.type,
    TuscanSingleFeetBase.type,
    TuscanSinglePlatformBase.type,
    WaldenBase.type,
    WaldenSingleBase.type,
    XBase.type,
    XSingleBase.type,
    AnglePictureFrameBase.type,
    AnglePictureFrameSingleBase.type,
    AnglePictureFrameCTCBase.type,
    ArchBase.type,
    ArchSingleBase.type,
    BoxFrameBase.type,
    ConnectedXBase.type,
    SlimConnectedXBase.type,
    SlimConnectedXSingleBase.type,
    ReflectionBase.type,
    ReflectionCTCBase.type,
    SinglePostBase.type,
    SinglePostSingleBase.type,
    XMetalBase.type,
    XMetalSingleBase.type,
    IvyBase.type,
    DremorTurnedBase.type,
    HerricksonTurnedBase.type,
    MidModernTaperBase.type,
    NarrowEnglishTurnedBase.type,
    OldEnglishTurnedBase.type,
    SlagleTurnedBase.type,
    TraditionalBase.type,
    TraditionalFlushBase.type,
    ReededBase.type,
    HershBase.type,
    TriflectionBase.type
]);
export const $Apron = new EnhancedAliasReflection('$Apron', [
    ApronBasic.type,
    ApronNone.type
]);
export const $Bench = new EnhancedAliasReflection('$Bench', [
    BenchBasic.type
]);
export const $TopOval = new EnhancedAliasReflection('$TopOval', [
    EllipticalOvalTop.type,
    RacetrackOvalTop.type
]);
export const $TopWithSide = new EnhancedAliasReflection('$TopWithSide', [
    SquareTop.type
]);
export const $TopWithWidthAndLength = new EnhancedAliasReflection('$TopWithWidthAndLength', [
    RectangleTop.type,
    EllipticalOvalTop.type,
    RacetrackOvalTop.type,
    BoatShapeTop.type
]);
export const $TopWithDiameter = new EnhancedAliasReflection('$TopWithDiameter', [
    RoundTop.type
]);
export const $TopWithRolledThickness = new EnhancedAliasReflection('$TopWithRolledThickness', [
    RectangleTop.type,
    SquareTop.type
]);
export const $BasePedestal = new EnhancedAliasReflection('$BasePedestal', [
    AnchorBase.type,
    AnchorSingleFeetBase.type,
    AnchorSinglePlatformBase.type,
    BellhouseBase.type,
    BellhouseSingleFeetBase.type,
    BellhouseSinglePlatformBase.type,
    BellyStretchedBase.type,
    BrewerBase.type,
    BrewerSingleBase.type,
    CaseyBase.type,
    CraftsmanBase.type,
    CraftsmanSingleBase.type,
    CrescentBase.type,
    CrescentSingleBase.type,
    DanaBase.type,
    DanaSingleBase.type,
    FranklinBase.type,
    FranklinSingleFeetBase.type,
    FranklinSinglePlatformBase.type,
    MarksBase.type,
    MeredithBase.type,
    MeredithSingleFeetBase.type,
    MeredithSinglePlatformBase.type,
    OswaldBase.type,
    OswaldSingleBase.type,
    PeruStretchedBase.type,
    RishBase.type,
    RishSingleBase.type,
    RogersBase.type,
    RogersSinglePlatformBase.type,
    TamaraBase.type,
    TamaraSingleBase.type,
    TuscanBase.type,
    TuscanSingleFeetBase.type,
    TuscanSinglePlatformBase.type,
    WaldenBase.type,
    WaldenSingleBase.type,
    XBase.type,
    XSingleBase.type,
    ReededBase.type,
    HershBase.type
]);
export const $BaseMetal = new EnhancedAliasReflection('$BaseMetal', [
    MantisBase.type,
    AnglePictureFrameBase.type,
    AnglePictureFrameSingleBase.type,
    AnglePictureFrameCTCBase.type,
    ArchBase.type,
    ArchSingleBase.type,
    BoxFrameBase.type,
    ConnectedXBase.type,
    SlimConnectedXBase.type,
    SlimConnectedXSingleBase.type,
    ReflectionBase.type,
    ReflectionCTCBase.type,
    SinglePostBase.type,
    SinglePostSingleBase.type,
    XMetalBase.type,
    XMetalSingleBase.type,
    TriflectionBase.type
]);
export const $BaseFourLeg = new EnhancedAliasReflection('$BaseFourLeg', [
    IvyBase.type,
    DremorTurnedBase.type,
    HerricksonTurnedBase.type,
    MidModernTaperBase.type,
    NarrowEnglishTurnedBase.type,
    OldEnglishTurnedBase.type,
    SlagleTurnedBase.type,
    TraditionalBase.type,
    TraditionalFlushBase.type
]);
export const $BaseSingleLeg = new EnhancedAliasReflection('$BaseSingleLeg', [
    BellyStretchedBase.type,
    BrewerSingleBase.type,
    AnchorSingleFeetBase.type,
    AnchorSinglePlatformBase.type,
    BellhouseSingleFeetBase.type,
    BellhouseSinglePlatformBase.type,
    CraftsmanSingleBase.type,
    CrescentSingleBase.type,
    DanaSingleBase.type,
    FranklinSingleFeetBase.type,
    FranklinSinglePlatformBase.type,
    MantisBase.type,
    MarksBase.type,
    MeredithSingleFeetBase.type,
    MeredithSinglePlatformBase.type,
    OswaldSingleBase.type,
    PeruStretchedBase.type,
    RishSingleBase.type,
    RogersSinglePlatformBase.type,
    TamaraSingleBase.type,
    TuscanSingleFeetBase.type,
    TuscanSinglePlatformBase.type,
    WaldenSingleBase.type,
    XSingleBase.type,
    AnglePictureFrameSingleBase.type,
    AnglePictureFrameCTCBase.type,
    ArchSingleBase.type,
    SlimConnectedXSingleBase.type,
    ReflectionBase.type,
    ReflectionCTCBase.type,
    SinglePostSingleBase.type,
    XMetalSingleBase.type,
    ReededBase.type
]);
export const $BaseDoubleLeg = new EnhancedAliasReflection('$BaseDoubleLeg', [
    AnchorBase.type,
    BellhouseBase.type,
    BrewerBase.type,
    CaseyBase.type,
    CraftsmanBase.type,
    CrescentBase.type,
    DanaBase.type,
    FranklinBase.type,
    MeredithBase.type,
    OswaldBase.type,
    RishBase.type,
    RogersBase.type,
    TamaraBase.type,
    TuscanBase.type,
    WaldenBase.type,
    XBase.type,
    AnglePictureFrameBase.type,
    ArchBase.type,
    BoxFrameBase.type,
    ConnectedXBase.type,
    SlimConnectedXBase.type,
    SinglePostBase.type,
    XMetalBase.type,
    HershBase.type,
    TriflectionBase.type
]);
export const $BaseWithPlatform = new EnhancedAliasReflection('$BaseWithPlatform', [
    AnchorSinglePlatformBase.type,
    BellhouseSinglePlatformBase.type,
    BellyStretchedBase.type,
    FranklinSinglePlatformBase.type,
    MeredithSinglePlatformBase.type,
    TuscanSinglePlatformBase.type,
    PeruStretchedBase.type,
    RogersSinglePlatformBase.type
]);
export const $BaseFourLegCombined = new EnhancedAliasReflection('$BaseFourLegCombined', [
    IvyBase.type
]);
export const $BaseFourLegSeparate = new EnhancedAliasReflection('$BaseFourLegSeparate', [
    DremorTurnedBase.type,
    HerricksonTurnedBase.type,
    MidModernTaperBase.type,
    NarrowEnglishTurnedBase.type,
    OldEnglishTurnedBase.type,
    SlagleTurnedBase.type,
    TraditionalBase.type,
    TraditionalFlushBase.type
]);
export const $TopWithSquareCorners = new EnhancedAliasReflection('$TopWithSquareCorners', [
    RectangleTop.type,
    SquareTop.type
]);
export const $TopWithRoundedCorners = new EnhancedAliasReflection('$TopWithRoundedCorners', [
    RoundTop.type,
    EllipticalOvalTop.type,
    RacetrackOvalTop.type,
    BoatShapeTop.type
]);
export const $StretchedBase = new EnhancedAliasReflection('$StretchedBase', [
    BellyStretchedBase.type,
    PeruStretchedBase.type
]);
export const $entityReflections = {
    Table: $Table,
    RectangleTop: $RectangleTop,
    SquareTop: $SquareTop,
    RoundTop: $RoundTop,
    EllipticalOvalTop: $EllipticalOvalTop,
    RacetrackOvalTop: $RacetrackOvalTop,
    BoatShapeTop: $BoatShapeTop,
    AnchorBase: $AnchorBase,
    AnchorSingleFeetBase: $AnchorSingleFeetBase,
    AnchorSinglePlatformBase: $AnchorSinglePlatformBase,
    BellhouseBase: $BellhouseBase,
    BellhouseSingleFeetBase: $BellhouseSingleFeetBase,
    BellhouseSinglePlatformBase: $BellhouseSinglePlatformBase,
    BellyStretchedBase: $BellyStretchedBase,
    BrewerBase: $BrewerBase,
    BrewerSingleBase: $BrewerSingleBase,
    CaseyBase: $CaseyBase,
    CraftsmanBase: $CraftsmanBase,
    CraftsmanSingleBase: $CraftsmanSingleBase,
    CrescentBase: $CrescentBase,
    CrescentSingleBase: $CrescentSingleBase,
    DanaBase: $DanaBase,
    DanaSingleBase: $DanaSingleBase,
    FranklinBase: $FranklinBase,
    FranklinSingleFeetBase: $FranklinSingleFeetBase,
    FranklinSinglePlatformBase: $FranklinSinglePlatformBase,
    MantisBase: $MantisBase,
    MarksBase: $MarksBase,
    MeredithBase: $MeredithBase,
    MeredithSingleFeetBase: $MeredithSingleFeetBase,
    MeredithSinglePlatformBase: $MeredithSinglePlatformBase,
    OswaldBase: $OswaldBase,
    OswaldSingleBase: $OswaldSingleBase,
    PeruStretchedBase: $PeruStretchedBase,
    RishBase: $RishBase,
    RishSingleBase: $RishSingleBase,
    RogersBase: $RogersBase,
    RogersSinglePlatformBase: $RogersSinglePlatformBase,
    TamaraBase: $TamaraBase,
    TamaraSingleBase: $TamaraSingleBase,
    TuscanBase: $TuscanBase,
    TuscanSingleFeetBase: $TuscanSingleFeetBase,
    TuscanSinglePlatformBase: $TuscanSinglePlatformBase,
    WaldenBase: $WaldenBase,
    WaldenSingleBase: $WaldenSingleBase,
    AnglePictureFrameBase: $AnglePictureFrameBase,
    XBase: $XBase,
    XSingleBase: $XSingleBase,
    AnglePictureFrameSingleBase: $AnglePictureFrameSingleBase,
    AnglePictureFrameCTCBase: $AnglePictureFrameCTCBase,
    ArchBase: $ArchBase,
    ArchSingleBase: $ArchSingleBase,
    BoxFrameBase: $BoxFrameBase,
    ConnectedXBase: $ConnectedXBase,
    SlimConnectedXBase: $SlimConnectedXBase,
    SlimConnectedXSingleBase: $SlimConnectedXSingleBase,
    ReflectionBase: $ReflectionBase,
    ReflectionCTCBase: $ReflectionCTCBase,
    SinglePostBase: $SinglePostBase,
    SinglePostSingleBase: $SinglePostSingleBase,
    XMetalBase: $XMetalBase,
    XMetalSingleBase: $XMetalSingleBase,
    IvyBase: $IvyBase,
    DremorTurnedBase: $DremorTurnedBase,
    HerricksonTurnedBase: $HerricksonTurnedBase,
    MidModernTaperBase: $MidModernTaperBase,
    NarrowEnglishTurnedBase: $NarrowEnglishTurnedBase,
    OldEnglishTurnedBase: $OldEnglishTurnedBase,
    SlagleTurnedBase: $SlagleTurnedBase,
    TraditionalBase: $TraditionalBase,
    TraditionalFlushBase: $TraditionalFlushBase,
    ReededBase: $ReededBase,
    HershBase: $HershBase,
    TriflectionBase: $TriflectionBase,
    ApronBasic: $ApronBasic,
    ApronNone: $ApronNone,
    BenchBasic: $BenchBasic
};

//# sourceMappingURL=enhanced-model.js.map